
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4340"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4340"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("29Z9A", function(module, exports) {

$parcel$export(module.exports, "default", () => $192bdbddff0869a5$export$2e2bcd8739ae039);

var $2TWNj = parcelRequire("2TWNj");
var $del55 = parcelRequire("del55");
var $dZQeP = parcelRequire("dZQeP");
var $cx8zM = parcelRequire("cx8zM");
var $iNPz2 = parcelRequire("iNPz2");
function $192bdbddff0869a5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $192bdbddff0869a5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $192bdbddff0869a5$var$_typeof(obj);
}
function $192bdbddff0869a5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $192bdbddff0869a5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $192bdbddff0869a5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $192bdbddff0869a5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $192bdbddff0869a5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $192bdbddff0869a5$var$_defineProperty(obj, key, value) {
    key = $192bdbddff0869a5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $192bdbddff0869a5$var$_toPropertyKey(arg) {
    var key = $192bdbddff0869a5$var$_toPrimitive(arg, "string");
    return $192bdbddff0869a5$var$_typeof(key) === "symbol" ? key : String(key);
}
function $192bdbddff0869a5$var$_toPrimitive(input, hint) {
    if ($192bdbddff0869a5$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($192bdbddff0869a5$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $192bdbddff0869a5$var$_slicedToArray(arr, i) {
    return $192bdbddff0869a5$var$_arrayWithHoles(arr) || $192bdbddff0869a5$var$_iterableToArrayLimit(arr, i) || $192bdbddff0869a5$var$_unsupportedIterableToArray(arr, i) || $192bdbddff0869a5$var$_nonIterableRest();
}
function $192bdbddff0869a5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $192bdbddff0869a5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $192bdbddff0869a5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $192bdbddff0869a5$var$_arrayLikeToArray(o, minLen);
}
function $192bdbddff0869a5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $192bdbddff0869a5$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $192bdbddff0869a5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $192bdbddff0869a5$var$withUsage = (0, $del55.createDocumentationMessageGenerator)({
    name: "range-input",
    connector: true
}, {
    name: "range-slider",
    connector: true
});
var $192bdbddff0869a5$var$$$type = "ais.range";
// @MAJOR: potentially we should consolidate these types
function $192bdbddff0869a5$var$toPrecision(_ref) {
    var min = _ref.min, max = _ref.max, precision = _ref.precision;
    var pow = Math.pow(10, precision);
    return {
        min: min ? Math.floor(min * pow) / pow : min,
        max: max ? Math.ceil(max * pow) / pow : max
    };
}
/**
 * **Range** connector provides the logic to create custom widget that will let
 * the user refine results using a numeric range.
 *
 * This connectors provides a `refine()` function that accepts bounds. It will also provide
 * information about the min and max bounds for the current result set.
 */ var $192bdbddff0869a5$var$connectRange = function connectRange(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $iNPz2.noop);
    (0, $2TWNj.checkRendering)(renderFn, $192bdbddff0869a5$var$withUsage());
    return function(widgetParams) {
        var _ref2 = widgetParams || {}, _ref2$attribute = _ref2.attribute, attribute = _ref2$attribute === void 0 ? "" : _ref2$attribute, minBound = _ref2.min, maxBound = _ref2.max, _ref2$precision = _ref2.precision, precision = _ref2$precision === void 0 ? 0 : _ref2$precision;
        if (!attribute) throw new Error($192bdbddff0869a5$var$withUsage("The `attribute` option is required."));
        if ((0, $cx8zM.isFiniteNumber)(minBound) && (0, $cx8zM.isFiniteNumber)(maxBound) && minBound > maxBound) throw new Error($192bdbddff0869a5$var$withUsage("The `max` option can't be lower than `min`."));
        var formatToNumber = function formatToNumber(v) {
            return Number(Number(v).toFixed(precision));
        };
        var rangeFormatter = {
            from: function from(v) {
                return v.toLocaleString();
            },
            to: function to(v) {
                return formatToNumber(v).toLocaleString();
            }
        };
        // eslint-disable-next-line complexity
        var getRefinedState = function getRefinedState(helper, currentRange, nextMin, nextMax) {
            var resolvedState = helper.state;
            var currentRangeMin = currentRange.min, currentRangeMax = currentRange.max;
            var _ref3 = resolvedState.getNumericRefinement(attribute, ">=") || [], _ref4 = $192bdbddff0869a5$var$_slicedToArray(_ref3, 1), min = _ref4[0];
            var _ref5 = resolvedState.getNumericRefinement(attribute, "<=") || [], _ref6 = $192bdbddff0869a5$var$_slicedToArray(_ref5, 1), max = _ref6[0];
            var isResetMin = nextMin === undefined || nextMin === "";
            var isResetMax = nextMax === undefined || nextMax === "";
            var _toPrecision = $192bdbddff0869a5$var$toPrecision({
                min: !isResetMin ? parseFloat(nextMin) : undefined,
                max: !isResetMax ? parseFloat(nextMax) : undefined,
                precision: precision
            }), nextMinAsNumber = _toPrecision.min, nextMaxAsNumber = _toPrecision.max;
            var newNextMin;
            if (!(0, $cx8zM.isFiniteNumber)(minBound) && currentRangeMin === nextMinAsNumber) newNextMin = undefined;
            else if ((0, $cx8zM.isFiniteNumber)(minBound) && isResetMin) newNextMin = minBound;
            else newNextMin = nextMinAsNumber;
            var newNextMax;
            if (!(0, $cx8zM.isFiniteNumber)(maxBound) && currentRangeMax === nextMaxAsNumber) newNextMax = undefined;
            else if ((0, $cx8zM.isFiniteNumber)(maxBound) && isResetMax) newNextMax = maxBound;
            else newNextMax = nextMaxAsNumber;
            var isResetNewNextMin = newNextMin === undefined;
            var isGreaterThanCurrentRange = (0, $cx8zM.isFiniteNumber)(currentRangeMin) && currentRangeMin <= newNextMin;
            var isMinValid = isResetNewNextMin || (0, $cx8zM.isFiniteNumber)(newNextMin) && (!(0, $cx8zM.isFiniteNumber)(currentRangeMin) || isGreaterThanCurrentRange);
            var isResetNewNextMax = newNextMax === undefined;
            var isLowerThanRange = (0, $cx8zM.isFiniteNumber)(newNextMax) && currentRangeMax >= newNextMax;
            var isMaxValid = isResetNewNextMax || (0, $cx8zM.isFiniteNumber)(newNextMax) && (!(0, $cx8zM.isFiniteNumber)(currentRangeMax) || isLowerThanRange);
            var hasMinChange = min !== newNextMin;
            var hasMaxChange = max !== newNextMax;
            if ((hasMinChange || hasMaxChange) && isMinValid && isMaxValid) {
                resolvedState = resolvedState.removeNumericRefinement(attribute);
                if ((0, $cx8zM.isFiniteNumber)(newNextMin)) resolvedState = resolvedState.addNumericRefinement(attribute, ">=", newNextMin);
                if ((0, $cx8zM.isFiniteNumber)(newNextMax)) resolvedState = resolvedState.addNumericRefinement(attribute, "<=", newNextMax);
                return resolvedState.resetPage();
            }
            return null;
        };
        var createSendEvent = function createSendEvent(instantSearchInstance) {
            return function() {
                if (arguments.length === 1) {
                    instantSearchInstance.sendEventToInsights(arguments.length <= 0 ? undefined : arguments[0]);
                    return;
                }
            };
        };
        function _getCurrentRange(stats) {
            var min;
            if ((0, $cx8zM.isFiniteNumber)(minBound)) min = minBound;
            else if ((0, $cx8zM.isFiniteNumber)(stats.min)) min = stats.min;
            else min = 0;
            var max;
            if ((0, $cx8zM.isFiniteNumber)(maxBound)) max = maxBound;
            else if ((0, $cx8zM.isFiniteNumber)(stats.max)) max = stats.max;
            else max = 0;
            return $192bdbddff0869a5$var$toPrecision({
                min: min,
                max: max,
                precision: precision
            });
        }
        function _getCurrentRefinement(helper) {
            var _ref7 = helper.getNumericRefinement(attribute, ">=") || [], _ref8 = $192bdbddff0869a5$var$_slicedToArray(_ref7, 1), minValue = _ref8[0];
            var _ref9 = helper.getNumericRefinement(attribute, "<=") || [], _ref10 = $192bdbddff0869a5$var$_slicedToArray(_ref9, 1), maxValue = _ref10[0];
            var min = (0, $cx8zM.isFiniteNumber)(minValue) ? minValue : -Infinity;
            var max = (0, $cx8zM.isFiniteNumber)(maxValue) ? maxValue : Infinity;
            return [
                min,
                max
            ];
        }
        function _refine(helper, currentRange) {
            return function() {
                var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
                    undefined,
                    undefined
                ], _ref12 = $192bdbddff0869a5$var$_slicedToArray(_ref11, 2), nextMin = _ref12[0], nextMax = _ref12[1];
                var refinedState = getRefinedState(helper, currentRange, nextMin, nextMax);
                if (refinedState) helper.setState(refinedState).search();
            };
        }
        return {
            $$type: $192bdbddff0869a5$var$$$type,
            init: function init(initOptions) {
                renderFn($192bdbddff0869a5$var$_objectSpread($192bdbddff0869a5$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: initOptions.instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                renderFn($192bdbddff0869a5$var$_objectSpread($192bdbddff0869a5$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: renderOptions.instantSearchInstance
                }), false);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $192bdbddff0869a5$var$_objectSpread($192bdbddff0869a5$var$_objectSpread({}, renderState), {}, {
                    range: $192bdbddff0869a5$var$_objectSpread($192bdbddff0869a5$var$_objectSpread({}, renderState.range), {}, $192bdbddff0869a5$var$_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref13) {
                var results = _ref13.results, helper = _ref13.helper, instantSearchInstance = _ref13.instantSearchInstance;
                var facetsFromResults = results && results.disjunctiveFacets || [];
                var facet = (0, $dZQeP.find)(facetsFromResults, function(facetResult) {
                    return facetResult.name === attribute;
                });
                var stats = facet && facet.stats || {
                    min: undefined,
                    max: undefined
                };
                var currentRange = _getCurrentRange(stats);
                var start = _getCurrentRefinement(helper);
                var refine;
                if (!results) // On first render pass an empty range
                // to be able to bypass the validation
                // related to it
                refine = _refine(helper, {
                    min: undefined,
                    max: undefined
                });
                else refine = _refine(helper, currentRange);
                return {
                    refine: refine,
                    canRefine: currentRange.min !== currentRange.max,
                    format: rangeFormatter,
                    range: currentRange,
                    sendEvent: createSendEvent(instantSearchInstance),
                    widgetParams: $192bdbddff0869a5$var$_objectSpread($192bdbddff0869a5$var$_objectSpread({}, widgetParams), {}, {
                        precision: precision
                    }),
                    start: start
                };
            },
            dispose: function dispose(_ref14) {
                var state = _ref14.state;
                unmountFn();
                return state.removeDisjunctiveFacet(attribute).removeNumericRefinement(attribute);
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref15) {
                var searchParameters = _ref15.searchParameters;
                var _searchParameters$get = searchParameters.getNumericRefinements(attribute), _searchParameters$get2 = _searchParameters$get[">="], min = _searchParameters$get2 === void 0 ? [] : _searchParameters$get2, _searchParameters$get3 = _searchParameters$get["<="], max = _searchParameters$get3 === void 0 ? [] : _searchParameters$get3;
                if (min.length === 0 && max.length === 0) return uiState;
                return $192bdbddff0869a5$var$_objectSpread($192bdbddff0869a5$var$_objectSpread({}, uiState), {}, {
                    range: $192bdbddff0869a5$var$_objectSpread($192bdbddff0869a5$var$_objectSpread({}, uiState.range), {}, $192bdbddff0869a5$var$_defineProperty({}, attribute, "".concat(min, ":").concat(max)))
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref16) {
                var uiState = _ref16.uiState;
                var widgetSearchParameters = searchParameters.addDisjunctiveFacet(attribute).setQueryParameters({
                    numericRefinements: $192bdbddff0869a5$var$_objectSpread($192bdbddff0869a5$var$_objectSpread({}, searchParameters.numericRefinements), {}, $192bdbddff0869a5$var$_defineProperty({}, attribute, {}))
                });
                if ((0, $cx8zM.isFiniteNumber)(minBound)) widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, ">=", minBound);
                if ((0, $cx8zM.isFiniteNumber)(maxBound)) widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, "<=", maxBound);
                var value = uiState.range && uiState.range[attribute];
                if (!value || value.indexOf(":") === -1) return widgetSearchParameters;
                var _value$split$map = value.split(":").map(parseFloat), _value$split$map2 = $192bdbddff0869a5$var$_slicedToArray(_value$split$map, 2), lowerBound = _value$split$map2[0], upperBound = _value$split$map2[1];
                if ((0, $cx8zM.isFiniteNumber)(lowerBound) && (!(0, $cx8zM.isFiniteNumber)(minBound) || minBound < lowerBound)) {
                    widgetSearchParameters = widgetSearchParameters.removeNumericRefinement(attribute, ">=");
                    widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, ">=", lowerBound);
                }
                if ((0, $cx8zM.isFiniteNumber)(upperBound) && (!(0, $cx8zM.isFiniteNumber)(maxBound) || upperBound < maxBound)) {
                    widgetSearchParameters = widgetSearchParameters.removeNumericRefinement(attribute, "<=");
                    widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, "<=", upperBound);
                }
                return widgetSearchParameters;
            }
        };
    };
};
var $192bdbddff0869a5$export$2e2bcd8739ae039 = $192bdbddff0869a5$var$connectRange;

});
parcelRegister("cx8zM", function(module, exports) {

$parcel$export(module.exports, "isFiniteNumber", () => $91ff381cc6a17987$export$cf6c09818bd7035a);
// This is the `Number.isFinite()` polyfill recommended by MDN.
// We do not provide any tests for this function.
// See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isFinite#Polyfill
// @MAJOR Replace with the native `Number.isFinite` method
function $91ff381cc6a17987$export$cf6c09818bd7035a(value) {
    return typeof value === "number" && isFinite(value);
}

});


parcelRegister("cobnL", function(module, exports) {

$parcel$export(module.exports, "default", () => $90508e31a3587aa7$export$2e2bcd8739ae039);

var $iQB5y = parcelRequire("iQB5y");

var $1Hdcz = parcelRequire("1Hdcz");

var $fgJNV = parcelRequire("fgJNV");

var $ffwuK = parcelRequire("ffwuK");

var $ipedu = parcelRequire("ipedu");

var $7OG5t = parcelRequire("7OG5t");

var $del55 = parcelRequire("del55");
var $6lpSe = parcelRequire("6lpSe");

var $egOAc = parcelRequire("egOAc");
function $90508e31a3587aa7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $90508e31a3587aa7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $90508e31a3587aa7$var$_typeof(obj);
}
function $90508e31a3587aa7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $90508e31a3587aa7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $90508e31a3587aa7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $90508e31a3587aa7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $90508e31a3587aa7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $90508e31a3587aa7$var$_defineProperty(obj, key, value) {
    key = $90508e31a3587aa7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $90508e31a3587aa7$var$_toPropertyKey(arg) {
    var key = $90508e31a3587aa7$var$_toPrimitive(arg, "string");
    return $90508e31a3587aa7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $90508e31a3587aa7$var$_toPrimitive(input, hint) {
    if ($90508e31a3587aa7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($90508e31a3587aa7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $90508e31a3587aa7$var$withUsage = (0, $del55.createDocumentationMessageGenerator)({
    name: "menu-select"
});
var $90508e31a3587aa7$var$suit = (0, $ipedu.component)("MenuSelect");
var $90508e31a3587aa7$var$renderer = function renderer(_ref) {
    var containerNode = _ref.containerNode, cssClasses = _ref.cssClasses, renderState = _ref.renderState, templates = _ref.templates;
    return function(_ref2, isFirstRendering) {
        var refine = _ref2.refine, items = _ref2.items, instantSearchInstance = _ref2.instantSearchInstance;
        if (isFirstRendering) {
            renderState.templateProps = (0, $7OG5t.prepareTemplateProps)({
                defaultTemplates: (0, $egOAc.default),
                templatesConfig: instantSearchInstance.templatesConfig,
                templates: templates
            });
            return;
        }
        (0, $1Hdcz.render)((0, $1Hdcz.h)((0, $fgJNV.default), {
            cssClasses: cssClasses,
            items: items,
            refine: refine,
            templateProps: renderState.templateProps
        }), containerNode);
    };
};
var $90508e31a3587aa7$var$menuSelect = function menuSelect(widgetParams) {
    var _ref3 = widgetParams || {}, container = _ref3.container, attribute = _ref3.attribute, _ref3$sortBy = _ref3.sortBy, sortBy = _ref3$sortBy === void 0 ? [
        "name:asc"
    ] : _ref3$sortBy, _ref3$limit = _ref3.limit, limit = _ref3$limit === void 0 ? 10 : _ref3$limit, _ref3$cssClasses = _ref3.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, _ref3$templates = _ref3.templates, templates = _ref3$templates === void 0 ? {} : _ref3$templates, transformItems = _ref3.transformItems;
    if (!container) throw new Error($90508e31a3587aa7$var$withUsage("The `container` option is required."));
    var containerNode = (0, $6lpSe.getContainerNode)(container);
    var cssClasses = {
        root: (0, $iQB5y.cx)($90508e31a3587aa7$var$suit(), userCssClasses.root),
        noRefinementRoot: (0, $iQB5y.cx)($90508e31a3587aa7$var$suit({
            modifierName: "noRefinement"
        }), userCssClasses.noRefinementRoot),
        select: (0, $iQB5y.cx)($90508e31a3587aa7$var$suit({
            descendantName: "select"
        }), userCssClasses.select),
        option: (0, $iQB5y.cx)($90508e31a3587aa7$var$suit({
            descendantName: "option"
        }), userCssClasses.option)
    };
    var specializedRenderer = $90508e31a3587aa7$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        renderState: {},
        templates: templates
    });
    var makeWidget = (0, $ffwuK.default)(specializedRenderer, function() {
        return (0, $1Hdcz.render)(null, containerNode);
    });
    return $90508e31a3587aa7$var$_objectSpread($90508e31a3587aa7$var$_objectSpread({}, makeWidget({
        attribute: attribute,
        limit: limit,
        sortBy: sortBy,
        transformItems: transformItems
    })), {}, {
        $$widgetType: "ais.menuSelect"
    });
};
var $90508e31a3587aa7$export$2e2bcd8739ae039 = $90508e31a3587aa7$var$menuSelect;

});
parcelRegister("fgJNV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1dbe16d886fbe4a$export$2e2bcd8739ae039);

var $iQB5y = parcelRequire("iQB5y");

var $1Hdcz = parcelRequire("1Hdcz");

var $dZQeP = parcelRequire("dZQeP");

var $b7YL7 = parcelRequire("b7YL7");
function $b1dbe16d886fbe4a$var$_extends() {
    $b1dbe16d886fbe4a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b1dbe16d886fbe4a$var$_extends.apply(this, arguments);
}
function $b1dbe16d886fbe4a$var$MenuSelect(_ref) {
    var cssClasses = _ref.cssClasses, templateProps = _ref.templateProps, items = _ref.items, refine = _ref.refine;
    var _ref2 = (0, $dZQeP.find)(items, function(item) {
        return item.isRefined;
    }) || {
        value: ""
    }, selectedValue = _ref2.value;
    return (0, $1Hdcz.h)("div", {
        className: (0, $iQB5y.cx)(cssClasses.root, items.length === 0 && cssClasses.noRefinementRoot)
    }, (0, $1Hdcz.h)("select", {
        className: cssClasses.select,
        value: selectedValue,
        onChange: function onChange(event) {
            refine(event.target.value);
        }
    }, (0, $1Hdcz.h)((0, $b7YL7.default), $b1dbe16d886fbe4a$var$_extends({}, templateProps, {
        templateKey: "defaultOption",
        rootTagName: "option",
        rootProps: {
            value: "",
            className: cssClasses.option
        }
    })), items.map(function(item) {
        return (0, $1Hdcz.h)((0, $b7YL7.default), $b1dbe16d886fbe4a$var$_extends({}, templateProps, {
            templateKey: "item",
            rootTagName: "option",
            rootProps: {
                value: item.value,
                className: cssClasses.option
            },
            key: item.value,
            data: item
        }));
    })));
}
var $b1dbe16d886fbe4a$export$2e2bcd8739ae039 = $b1dbe16d886fbe4a$var$MenuSelect;

});

parcelRegister("ffwuK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1a1768d4cd3318b$export$2e2bcd8739ae039);

var $2TWNj = parcelRequire("2TWNj");
var $del55 = parcelRequire("del55");
var $6N6DO = parcelRequire("6N6DO");
var $iNPz2 = parcelRequire("iNPz2");
var $b1a1768d4cd3318b$var$_excluded = [
    "name",
    "escapedValue",
    "path"
];
function $b1a1768d4cd3318b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b1a1768d4cd3318b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b1a1768d4cd3318b$var$_typeof(obj);
}
function $b1a1768d4cd3318b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b1a1768d4cd3318b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b1a1768d4cd3318b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b1a1768d4cd3318b$var$_slicedToArray(arr, i) {
    return $b1a1768d4cd3318b$var$_arrayWithHoles(arr) || $b1a1768d4cd3318b$var$_iterableToArrayLimit(arr, i) || $b1a1768d4cd3318b$var$_unsupportedIterableToArray(arr, i) || $b1a1768d4cd3318b$var$_nonIterableRest();
}
function $b1a1768d4cd3318b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b1a1768d4cd3318b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b1a1768d4cd3318b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b1a1768d4cd3318b$var$_arrayLikeToArray(o, minLen);
}
function $b1a1768d4cd3318b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b1a1768d4cd3318b$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $b1a1768d4cd3318b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b1a1768d4cd3318b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b1a1768d4cd3318b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b1a1768d4cd3318b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b1a1768d4cd3318b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b1a1768d4cd3318b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b1a1768d4cd3318b$var$_defineProperty(obj, key, value) {
    key = $b1a1768d4cd3318b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b1a1768d4cd3318b$var$_toPropertyKey(arg) {
    var key = $b1a1768d4cd3318b$var$_toPrimitive(arg, "string");
    return $b1a1768d4cd3318b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b1a1768d4cd3318b$var$_toPrimitive(input, hint) {
    if ($b1a1768d4cd3318b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b1a1768d4cd3318b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $b1a1768d4cd3318b$var$withUsage = (0, $del55.createDocumentationMessageGenerator)({
    name: "menu",
    connector: true
});
var $b1a1768d4cd3318b$var$DEFAULT_SORT = [
    "isRefined",
    "name:asc"
];
/**
 * **Menu** connector provides the logic to build a widget that will give the user the ability to choose a single value for a specific facet. The typical usage of menu is for navigation in categories.
 *
 * This connector provides a `toggleShowMore()` function to display more or less items and a `refine()`
 * function to select an item. While selecting a new element, the `refine` will also unselect the
 * one that is currently selected.
 *
 * **Requirement:** the attribute passed as `attribute` must be present in "attributes for faceting" on the Algolia dashboard or configured as attributesForFaceting via a set settings call to the Algolia API.
 */ var $b1a1768d4cd3318b$var$connectMenu = function connectMenu(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $iNPz2.noop);
    (0, $2TWNj.checkRendering)(renderFn, $b1a1768d4cd3318b$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, attribute = _ref.attribute, _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? 10 : _ref$limit, _ref$showMore = _ref.showMore, showMore = _ref$showMore === void 0 ? false : _ref$showMore, _ref$showMoreLimit = _ref.showMoreLimit, showMoreLimit = _ref$showMoreLimit === void 0 ? 20 : _ref$showMoreLimit, _ref$sortBy = _ref.sortBy, sortBy = _ref$sortBy === void 0 ? $b1a1768d4cd3318b$var$DEFAULT_SORT : _ref$sortBy, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
            return items;
        } : _ref$transformItems;
        if (!attribute) throw new Error($b1a1768d4cd3318b$var$withUsage("The `attribute` option is required."));
        if (showMore === true && showMoreLimit <= limit) throw new Error($b1a1768d4cd3318b$var$withUsage("The `showMoreLimit` option must be greater than `limit`."));
        var sendEvent;
        var _createURL;
        var _refine;
        // Provide the same function to the `renderFn` so that way the user
        // has to only bind it once when `isFirstRendering` for instance
        var isShowingMore = false;
        var toggleShowMore = function toggleShowMore() {};
        function createToggleShowMore(renderOptions, widget) {
            return function() {
                isShowingMore = !isShowingMore;
                widget.render(renderOptions);
            };
        }
        function cachedToggleShowMore() {
            toggleShowMore();
        }
        function getLimit() {
            return isShowingMore ? showMoreLimit : limit;
        }
        return {
            $$type: "ais.menu",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($b1a1768d4cd3318b$var$_objectSpread($b1a1768d4cd3318b$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($b1a1768d4cd3318b$var$_objectSpread($b1a1768d4cd3318b$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref2) {
                var state = _ref2.state;
                unmountFn();
                return state.removeHierarchicalFacet(attribute).setQueryParameter("maxValuesPerFacet", undefined);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $b1a1768d4cd3318b$var$_objectSpread($b1a1768d4cd3318b$var$_objectSpread({}, renderState), {}, {
                    menu: $b1a1768d4cd3318b$var$_objectSpread($b1a1768d4cd3318b$var$_objectSpread({}, renderState.menu), {}, $b1a1768d4cd3318b$var$_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
                });
            },
            getWidgetRenderState: function getWidgetRenderState(renderOptions) {
                var _this = this;
                var results = renderOptions.results, createURL = renderOptions.createURL, instantSearchInstance = renderOptions.instantSearchInstance, helper = renderOptions.helper;
                var items = [];
                var canToggleShowMore = false;
                if (!sendEvent) sendEvent = (0, $6N6DO.createSendEventForFacet)({
                    instantSearchInstance: instantSearchInstance,
                    helper: helper,
                    attribute: attribute,
                    widgetType: this.$$type
                });
                if (!_createURL) _createURL = function _createURL(facetValue) {
                    return createURL(function(uiState) {
                        return _this.getWidgetUiState(uiState, {
                            searchParameters: helper.state.resetPage().toggleFacetRefinement(attribute, facetValue),
                            helper: helper
                        });
                    });
                };
                if (!_refine) _refine = function _refine(facetValue) {
                    var _helper$getHierarchic = helper.getHierarchicalFacetBreadcrumb(attribute), _helper$getHierarchic2 = $b1a1768d4cd3318b$var$_slicedToArray(_helper$getHierarchic, 1), refinedItem = _helper$getHierarchic2[0];
                    sendEvent("click:internal", facetValue ? facetValue : refinedItem);
                    helper.toggleFacetRefinement(attribute, facetValue ? facetValue : refinedItem).search();
                };
                if (renderOptions.results) toggleShowMore = createToggleShowMore(renderOptions, this);
                if (results) {
                    var facetValues = results.getFacetValues(attribute, {
                        sortBy: sortBy,
                        facetOrdering: sortBy === $b1a1768d4cd3318b$var$DEFAULT_SORT
                    });
                    var facetItems = facetValues && !Array.isArray(facetValues) && facetValues.data ? facetValues.data : [];
                    canToggleShowMore = showMore && (isShowingMore || facetItems.length > getLimit());
                    items = transformItems(facetItems.slice(0, getLimit()).map(function(_ref3) {
                        var label = _ref3.name, value = _ref3.escapedValue, path = _ref3.path, item = $b1a1768d4cd3318b$var$_objectWithoutProperties(_ref3, $b1a1768d4cd3318b$var$_excluded);
                        return $b1a1768d4cd3318b$var$_objectSpread($b1a1768d4cd3318b$var$_objectSpread({}, item), {}, {
                            label: label,
                            value: value
                        });
                    }), {
                        results: results
                    });
                }
                return {
                    items: items,
                    createURL: _createURL,
                    refine: _refine,
                    sendEvent: sendEvent,
                    canRefine: items.length > 0,
                    widgetParams: widgetParams,
                    isShowingMore: isShowingMore,
                    toggleShowMore: cachedToggleShowMore,
                    canToggleShowMore: canToggleShowMore
                };
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
                var searchParameters = _ref4.searchParameters;
                var _searchParameters$get = searchParameters.getHierarchicalFacetBreadcrumb(attribute), _searchParameters$get2 = $b1a1768d4cd3318b$var$_slicedToArray(_searchParameters$get, 1), value = _searchParameters$get2[0];
                return $b1a1768d4cd3318b$var$removeEmptyRefinementsFromUiState($b1a1768d4cd3318b$var$_objectSpread($b1a1768d4cd3318b$var$_objectSpread({}, uiState), {}, {
                    menu: $b1a1768d4cd3318b$var$_objectSpread($b1a1768d4cd3318b$var$_objectSpread({}, uiState.menu), {}, $b1a1768d4cd3318b$var$_defineProperty({}, attribute, value))
                }), attribute);
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
                var uiState = _ref5.uiState;
                var value = uiState.menu && uiState.menu[attribute];
                if (searchParameters.isConjunctiveFacet(attribute) || searchParameters.isDisjunctiveFacet(attribute)) return searchParameters;
                var withFacetConfiguration = searchParameters.removeHierarchicalFacet(attribute).addHierarchicalFacet({
                    name: attribute,
                    attributes: [
                        attribute
                    ]
                });
                var currentMaxValuesPerFacet = withFacetConfiguration.maxValuesPerFacet || 0;
                var nextMaxValuesPerFacet = Math.max(currentMaxValuesPerFacet, showMore ? showMoreLimit : limit);
                var withMaxValuesPerFacet = withFacetConfiguration.setQueryParameter("maxValuesPerFacet", nextMaxValuesPerFacet);
                if (!value) return withMaxValuesPerFacet.setQueryParameters({
                    hierarchicalFacetsRefinements: $b1a1768d4cd3318b$var$_objectSpread($b1a1768d4cd3318b$var$_objectSpread({}, withMaxValuesPerFacet.hierarchicalFacetsRefinements), {}, $b1a1768d4cd3318b$var$_defineProperty({}, attribute, []))
                });
                return withMaxValuesPerFacet.addHierarchicalFacetRefinement(attribute, value);
            }
        };
    };
};
function $b1a1768d4cd3318b$var$removeEmptyRefinementsFromUiState(indexUiState, attribute) {
    if (!indexUiState.menu) return indexUiState;
    if (indexUiState.menu[attribute] === undefined) delete indexUiState.menu[attribute];
    if (Object.keys(indexUiState.menu).length === 0) delete indexUiState.menu;
    return indexUiState;
}
var $b1a1768d4cd3318b$export$2e2bcd8739ae039 = $b1a1768d4cd3318b$var$connectMenu;

});

parcelRegister("egOAc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a639cc0678e4515d$export$2e2bcd8739ae039);

var $aiWu2 = parcelRequire("aiWu2");
var $a639cc0678e4515d$var$defaultTemplates = {
    item: function item(_ref) {
        var label = _ref.label, count = _ref.count;
        return "".concat(label, " (").concat((0, $aiWu2.formatNumber)(count), ")");
    },
    defaultOption: function defaultOption() {
        return "See all";
    }
};
var $a639cc0678e4515d$export$2e2bcd8739ae039 = $a639cc0678e4515d$var$defaultTemplates;

});


parcelRegister("3bzuQ", function(module, exports) {

$parcel$export(module.exports, "textDateAfter", () => $251def0cb620c869$export$ab7dd5151c1fb74f);
$parcel$export(module.exports, "textDateBefore", () => $251def0cb620c869$export$6a7a13dc378fffa4);
parcelRequire("hR2Nb");
var $bxn76 = parcelRequire("bxn76");
const $251def0cb620c869$export$ab7dd5151c1fb74f = (renderOptions, isFirstRender)=>{
    const { widgetParams: widgetParams, refine: refine } = renderOptions;
    if (isFirstRender) {
        // define a method to handle the event
        const a = (event)=>{
            event.preventDefault();
            const input = event.target.value;
            const epochSec = (0, $bxn76.default).fromISO(input).toSeconds();
            refine([
                undefined,
                epochSec
            ]);
        };
        //
        const el = document.querySelector(widgetParams.el);
        el.addEventListener("change", a);
    // el.addEventListener('keyup', a)  // or debounce this.
    }
};
const $251def0cb620c869$export$6a7a13dc378fffa4 = (renderOptions, isFirstRender)=>{
    const { widgetParams: widgetParams, refine: refine } = renderOptions;
    if (isFirstRender) {
        // define a method to handle the event
        const a = (event)=>{
            event.preventDefault();
            const input = event.target.value;
            const epochSec = (0, $bxn76.default).fromISO(input).toSeconds();
            refine([
                epochSec
            ]);
        };
        //
        const el = document.querySelector(widgetParams.el);
        el.addEventListener("change", a);
    // el.addEventListener('keyup', a)  // or debounce this.
    }
};

});
parcelRegister("hR2Nb", function(module, exports) {

$parcel$export(module.exports, "DateTime", () => (parcelRequire("bxn76")).default);

var $bxn76 = parcelRequire("bxn76");

var $fptYk = parcelRequire("fptYk");

var $crAXh = parcelRequire("crAXh");

var $s4LIV = parcelRequire("s4LIV");

var $5uPms = parcelRequire("5uPms");

var $2S7RT = parcelRequire("2S7RT");

var $lzaec = parcelRequire("lzaec");

var $4JNEw = parcelRequire("4JNEw");

var $aJb6U = parcelRequire("aJb6U");

var $h0abM = parcelRequire("h0abM");
const $cff98d6b585c379e$export$a4ad2735b021c132 = "3.5.0";

});
parcelRegister("bxn76", function(module, exports) {

$parcel$export(module.exports, "default", () => $8664b4a97d8239ef$export$2e2bcd8739ae039);
$parcel$export(module.exports, "friendlyDateTime", () => $8664b4a97d8239ef$export$d207855dff529fc9);

var $fptYk = parcelRequire("fptYk");

var $crAXh = parcelRequire("crAXh");

var $h0abM = parcelRequire("h0abM");

var $s4LIV = parcelRequire("s4LIV");

var $2lprD = parcelRequire("2lprD");

var $2S7RT = parcelRequire("2S7RT");

var $hi2rW = parcelRequire("hi2rW");

var $8XfCP = parcelRequire("8XfCP");

var $fcA62 = parcelRequire("fcA62");

var $4Plx3 = parcelRequire("4Plx3");

var $jJizu = parcelRequire("jJizu");

var $kdX7T = parcelRequire("kdX7T");

var $70NWa = parcelRequire("70NWa");

var $9BxO1 = parcelRequire("9BxO1");

var $4vuXU = parcelRequire("4vuXU");

var $f6Tt7 = parcelRequire("f6Tt7");
const $8664b4a97d8239ef$var$INVALID = "Invalid DateTime";
const $8664b4a97d8239ef$var$MAX_DATE = 8.64e15;
function $8664b4a97d8239ef$var$unsupportedZone(zone) {
    return new (0, $f6Tt7.default)("unsupported zone", `the zone "${zone.name}" is not supported`);
}
// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */ function $8664b4a97d8239ef$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = (0, $70NWa.gregorianToWeek)(dt.c);
    return dt.weekData;
}
/**
 * @param {DateTime} dt
 */ function $8664b4a97d8239ef$var$possiblyCachedLocalWeekData(dt) {
    if (dt.localWeekData === null) dt.localWeekData = (0, $70NWa.gregorianToWeek)(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
    return dt.localWeekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $8664b4a97d8239ef$var$clone(inst, alts) {
    const current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $8664b4a97d8239ef$export$2e2bcd8739ae039({
        ...current,
        ...alts,
        old: current
    });
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $8664b4a97d8239ef$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    let utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    const o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    const o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function $8664b4a97d8239ef$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    const d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function $8664b4a97d8239ef$var$objToTS(obj, offset, zone) {
    return $8664b4a97d8239ef$var$fixOffset((0, $8XfCP.objToLocalTS)(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function $8664b4a97d8239ef$var$adjustTime(inst, dur) {
    const oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = {
        ...inst.c,
        year: year,
        month: month,
        day: Math.min(inst.c.day, (0, $8XfCP.daysInMonth)(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }, millisToAdd = (0, $fptYk.default).fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = (0, $8XfCP.objToLocalTS)(c);
    let [ts, o] = $8664b4a97d8239ef$var$fixOffset(localTS, oPre, inst.zone);
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function $8664b4a97d8239ef$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    const { setZone: setZone, zone: zone } = opts;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        const interpretationZone = parsedZone || zone, inst = $8664b4a97d8239ef$export$2e2bcd8739ae039.fromObject(parsed, {
            ...opts,
            zone: interpretationZone,
            specificOffset: specificOffset
        });
        return setZone ? inst : inst.setZone(zone);
    } else return $8664b4a97d8239ef$export$2e2bcd8739ae039.invalid(new (0, $f6Tt7.default)("unparsable", `the input "${text}" can't be parsed as ${format}`));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $8664b4a97d8239ef$var$toTechFormat(dt, format, allowZ = true) {
    return dt.isValid ? (0, $2lprD.default).create((0, $hi2rW.default).create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $8664b4a97d8239ef$var$toISODate(o, extended) {
    const longFormat = o.c.year > 9999 || o.c.year < 0;
    let c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += (0, $8XfCP.padStart)(o.c.year, longFormat ? 6 : 4);
    if (extended) {
        c += "-";
        c += (0, $8XfCP.padStart)(o.c.month);
        c += "-";
        c += (0, $8XfCP.padStart)(o.c.day);
    } else {
        c += (0, $8XfCP.padStart)(o.c.month);
        c += (0, $8XfCP.padStart)(o.c.day);
    }
    return c;
}
function $8664b4a97d8239ef$var$toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
    let c = (0, $8XfCP.padStart)(o.c.hour);
    if (extended) {
        c += ":";
        c += (0, $8XfCP.padStart)(o.c.minute);
        if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) c += ":";
    } else c += (0, $8XfCP.padStart)(o.c.minute);
    if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
        c += (0, $8XfCP.padStart)(o.c.second);
        if (o.c.millisecond !== 0 || !suppressMilliseconds) {
            c += ".";
            c += (0, $8XfCP.padStart)(o.c.millisecond, 3);
        }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += (0, $8XfCP.padStart)(Math.trunc(-o.o / 60));
            c += ":";
            c += (0, $8XfCP.padStart)(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += (0, $8XfCP.padStart)(Math.trunc(o.o / 60));
            c += ":";
            c += (0, $8XfCP.padStart)(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
const $8664b4a97d8239ef$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $8664b4a97d8239ef$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $8664b4a97d8239ef$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
const $8664b4a97d8239ef$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $8664b4a97d8239ef$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $8664b4a97d8239ef$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function $8664b4a97d8239ef$var$normalizeUnit(unit) {
    const normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new (0, $4vuXU.InvalidUnitError)(unit);
    return normalized;
}
function $8664b4a97d8239ef$var$normalizeUnitWithLocalWeeks(unit) {
    switch(unit.toLowerCase()){
        case "localweekday":
        case "localweekdays":
            return "localWeekday";
        case "localweeknumber":
        case "localweeknumbers":
            return "localWeekNumber";
        case "localweekyear":
        case "localweekyears":
            return "localWeekYear";
        default:
            return $8664b4a97d8239ef$var$normalizeUnit(unit);
    }
}
// cache offsets for zones based on the current timestamp when this function is
// first called. When we are handling a datetime from components like (year,
// month, day, hour) in a time zone, we need a guess about what the timezone
// offset is so that we can convert into a UTC timestamp. One way is to find the
// offset of now in the zone. The actual date may have a different offset (for
// example, if we handle a date in June while we're in December in a zone that
// observes DST), but we can check and adjust that.
//
// When handling many dates, calculating the offset for now every time is
// expensive. It's just a guess, so we can cache the offset to use even if we
// are right on a time change boundary (we'll just correct in the other
// direction). Using a timestamp from first read is a slight optimization for
// handling dates close to the current date, since those dates will usually be
// in the same offset (we could set the timestamp statically, instead). We use a
// single timestamp for all zones to make things a bit more predictable.
//
// This is safe for quickDT (used by local() and utc()) because we don't fill in
// higher-order units from tsNow (as we do in fromObject, this requires that
// offset is calculated from tsNow).
function $8664b4a97d8239ef$var$guessOffsetForZone(zone) {
    if (!$8664b4a97d8239ef$var$zoneOffsetGuessCache[zone]) {
        if ($8664b4a97d8239ef$var$zoneOffsetTs === undefined) $8664b4a97d8239ef$var$zoneOffsetTs = (0, $h0abM.default).now();
        $8664b4a97d8239ef$var$zoneOffsetGuessCache[zone] = zone.offset($8664b4a97d8239ef$var$zoneOffsetTs);
    }
    return $8664b4a97d8239ef$var$zoneOffsetGuessCache[zone];
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $8664b4a97d8239ef$var$quickDT(obj, opts) {
    const zone = (0, $fcA62.normalizeZone)(opts.zone, (0, $h0abM.default).defaultZone);
    if (!zone.isValid) return $8664b4a97d8239ef$export$2e2bcd8739ae039.invalid($8664b4a97d8239ef$var$unsupportedZone(zone));
    const loc = (0, $hi2rW.default).fromObject(opts);
    let ts, o;
    // assume we have the higher-order units
    if (!(0, $8XfCP.isUndefined)(obj.year)) {
        for (const u of $8664b4a97d8239ef$var$orderedUnits)if ((0, $8XfCP.isUndefined)(obj[u])) obj[u] = $8664b4a97d8239ef$var$defaultUnitValues[u];
        const invalid = (0, $70NWa.hasInvalidGregorianData)(obj) || (0, $70NWa.hasInvalidTimeData)(obj);
        if (invalid) return $8664b4a97d8239ef$export$2e2bcd8739ae039.invalid(invalid);
        const offsetProvis = $8664b4a97d8239ef$var$guessOffsetForZone(zone);
        [ts, o] = $8664b4a97d8239ef$var$objToTS(obj, offsetProvis, zone);
    } else ts = (0, $h0abM.default).now();
    return new $8664b4a97d8239ef$export$2e2bcd8739ae039({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $8664b4a97d8239ef$var$diffRelative(start, end, opts) {
    const round = (0, $8XfCP.isUndefined)(opts.round) ? true : opts.round, format = (c, unit)=>{
        c = (0, $8XfCP.roundTo)(c, round || opts.calendary ? 0 : 2, true);
        const formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = (unit)=>{
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for (const unit of opts.units){
        const count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $8664b4a97d8239ef$var$lastOpts(argList) {
    let opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * Timestamp to use for cached zone offset guesses (exposed for test)
 */ let $8664b4a97d8239ef$var$zoneOffsetTs;
/**
 * Cache for zone offset guesses (exposed for test).
 *
 * This optimizes quickDT via guessOffsetForZone to avoid repeated calls of
 * zone.offset().
 */ let $8664b4a97d8239ef$var$zoneOffsetGuessCache = {};
class $8664b4a97d8239ef$export$2e2bcd8739ae039 {
    /**
   * @access private
   */ constructor(config){
        const zone = config.zone || (0, $h0abM.default).defaultZone;
        let invalid = config.invalid || (Number.isNaN(config.ts) ? new (0, $f6Tt7.default)("invalid input") : null) || (!zone.isValid ? $8664b4a97d8239ef$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = (0, $8XfCP.isUndefined)(config.ts) ? (0, $h0abM.default).now() : config.ts;
        let c = null, o = null;
        if (!invalid) {
            const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) [c, o] = [
                config.old.c,
                config.old.o
            ];
            else {
                // If an offset has been passed and we have not been called from
                // clone(), we can trust it and avoid the offset calculation.
                const ot = (0, $8XfCP.isNumber)(config.o) && !config.old ? config.o : zone.offset(this.ts);
                c = $8664b4a97d8239ef$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new (0, $f6Tt7.default)("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || (0, $hi2rW.default).create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.localWeekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ static now() {
        return new $8664b4a97d8239ef$export$2e2bcd8739ae039({});
    }
    /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */ static local() {
        const [opts, args] = $8664b4a97d8239ef$var$lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
        return $8664b4a97d8239ef$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    }
    /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */ static utc() {
        const [opts, args] = $8664b4a97d8239ef$var$lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
        opts.zone = (0, $2S7RT.default).utcInstance;
        return $8664b4a97d8239ef$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    }
    /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */ static fromJSDate(date, options = {}) {
        const ts = (0, $8XfCP.isDate)(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return $8664b4a97d8239ef$export$2e2bcd8739ae039.invalid("invalid input");
        const zoneToUse = (0, $fcA62.normalizeZone)(options.zone, (0, $h0abM.default).defaultZone);
        if (!zoneToUse.isValid) return $8664b4a97d8239ef$export$2e2bcd8739ae039.invalid($8664b4a97d8239ef$var$unsupportedZone(zoneToUse));
        return new $8664b4a97d8239ef$export$2e2bcd8739ae039({
            ts: ts,
            zone: zoneToUse,
            loc: (0, $hi2rW.default).fromObject(options)
        });
    }
    /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */ static fromMillis(milliseconds, options = {}) {
        if (!(0, $8XfCP.isNumber)(milliseconds)) throw new (0, $4vuXU.InvalidArgumentError)(`fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`);
        else if (milliseconds < -$8664b4a97d8239ef$var$MAX_DATE || milliseconds > $8664b4a97d8239ef$var$MAX_DATE) // this isn't perfect because we can still end up out of range because of additional shifting, but it's a start
        return $8664b4a97d8239ef$export$2e2bcd8739ae039.invalid("Timestamp out of range");
        else return new $8664b4a97d8239ef$export$2e2bcd8739ae039({
            ts: milliseconds,
            zone: (0, $fcA62.normalizeZone)(options.zone, (0, $h0abM.default).defaultZone),
            loc: (0, $hi2rW.default).fromObject(options)
        });
    }
    /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */ static fromSeconds(seconds, options = {}) {
        if (!(0, $8XfCP.isNumber)(seconds)) throw new (0, $4vuXU.InvalidArgumentError)("fromSeconds requires a numerical input");
        else return new $8664b4a97d8239ef$export$2e2bcd8739ae039({
            ts: seconds * 1000,
            zone: (0, $fcA62.normalizeZone)(options.zone, (0, $h0abM.default).defaultZone),
            loc: (0, $hi2rW.default).fromObject(options)
        });
    }
    /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */ static fromObject(obj, opts = {}) {
        obj = obj || {};
        const zoneToUse = (0, $fcA62.normalizeZone)(opts.zone, (0, $h0abM.default).defaultZone);
        if (!zoneToUse.isValid) return $8664b4a97d8239ef$export$2e2bcd8739ae039.invalid($8664b4a97d8239ef$var$unsupportedZone(zoneToUse));
        const loc = (0, $hi2rW.default).fromObject(opts);
        const normalized = (0, $8XfCP.normalizeObject)(obj, $8664b4a97d8239ef$var$normalizeUnitWithLocalWeeks);
        const { minDaysInFirstWeek: minDaysInFirstWeek, startOfWeek: startOfWeek } = (0, $70NWa.usesLocalWeekValues)(normalized, loc);
        const tsNow = (0, $h0abM.default).now(), offsetProvis = !(0, $8XfCP.isUndefined)(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !(0, $8XfCP.isUndefined)(normalized.ordinal), containsGregorYear = !(0, $8XfCP.isUndefined)(normalized.year), containsGregorMD = !(0, $8XfCP.isUndefined)(normalized.month) || !(0, $8XfCP.isUndefined)(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new (0, $4vuXU.ConflictingSpecificationError)("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new (0, $4vuXU.ConflictingSpecificationError)("Can't mix ordinal dates with month/day");
        const useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        let units, defaultValues, objNow = $8664b4a97d8239ef$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $8664b4a97d8239ef$var$orderedWeekUnits;
            defaultValues = $8664b4a97d8239ef$var$defaultWeekUnitValues;
            objNow = (0, $70NWa.gregorianToWeek)(objNow, minDaysInFirstWeek, startOfWeek);
        } else if (containsOrdinal) {
            units = $8664b4a97d8239ef$var$orderedOrdinalUnits;
            defaultValues = $8664b4a97d8239ef$var$defaultOrdinalUnitValues;
            objNow = (0, $70NWa.gregorianToOrdinal)(objNow);
        } else {
            units = $8664b4a97d8239ef$var$orderedUnits;
            defaultValues = $8664b4a97d8239ef$var$defaultUnitValues;
        }
        // set default values for missing stuff
        let foundFirst = false;
        for (const u of units){
            const v = normalized[u];
            if (!(0, $8XfCP.isUndefined)(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        const higherOrderInvalid = useWeekData ? (0, $70NWa.hasInvalidWeekData)(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? (0, $70NWa.hasInvalidOrdinalData)(normalized) : (0, $70NWa.hasInvalidGregorianData)(normalized), invalid = higherOrderInvalid || (0, $70NWa.hasInvalidTimeData)(normalized);
        if (invalid) return $8664b4a97d8239ef$export$2e2bcd8739ae039.invalid(invalid);
        // compute the actual time
        const gregorian = useWeekData ? (0, $70NWa.weekToGregorian)(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? (0, $70NWa.ordinalToGregorian)(normalized) : normalized, [tsFinal, offsetFinal] = $8664b4a97d8239ef$var$objToTS(gregorian, offsetProvis, zoneToUse), inst = new $8664b4a97d8239ef$export$2e2bcd8739ae039({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return $8664b4a97d8239ef$export$2e2bcd8739ae039.invalid("mismatched weekday", `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`);
        if (!inst.isValid) return $8664b4a97d8239ef$export$2e2bcd8739ae039.invalid(inst.invalid);
        return inst;
    }
    /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */ static fromISO(text, opts = {}) {
        const [vals, parsedZone] = (0, $jJizu.parseISODate)(text);
        return $8664b4a97d8239ef$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    }
    /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */ static fromRFC2822(text, opts = {}) {
        const [vals, parsedZone] = (0, $jJizu.parseRFC2822Date)(text);
        return $8664b4a97d8239ef$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    }
    /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */ static fromHTTP(text, opts = {}) {
        const [vals, parsedZone] = (0, $jJizu.parseHTTPDate)(text);
        return $8664b4a97d8239ef$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    }
    /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */ static fromFormat(text, fmt, opts = {}) {
        if ((0, $8XfCP.isUndefined)(text) || (0, $8XfCP.isUndefined)(fmt)) throw new (0, $4vuXU.InvalidArgumentError)("fromFormat requires an input string and a format");
        const { locale: locale = null, numberingSystem: numberingSystem = null } = opts, localeToUse = (0, $hi2rW.default).fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), [vals, parsedZone, specificOffset, invalid] = (0, $kdX7T.parseFromTokens)(localeToUse, text, fmt);
        if (invalid) return $8664b4a97d8239ef$export$2e2bcd8739ae039.invalid(invalid);
        else return $8664b4a97d8239ef$var$parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
    /**
   * @deprecated use fromFormat instead
   */ static fromString(text, fmt, opts = {}) {
        return $8664b4a97d8239ef$export$2e2bcd8739ae039.fromFormat(text, fmt, opts);
    }
    /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */ static fromSQL(text, opts = {}) {
        const [vals, parsedZone] = (0, $jJizu.parseSQL)(text);
        return $8664b4a97d8239ef$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    }
    /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */ static invalid(reason, explanation = null) {
        if (!reason) throw new (0, $4vuXU.InvalidArgumentError)("need to specify a reason the DateTime is invalid");
        const invalid = reason instanceof (0, $f6Tt7.default) ? reason : new (0, $f6Tt7.default)(reason, explanation);
        if ((0, $h0abM.default).throwOnInvalid) throw new (0, $4vuXU.InvalidDateTimeError)(invalid);
        else return new $8664b4a97d8239ef$export$2e2bcd8739ae039({
            invalid: invalid
        });
    }
    /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ static isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    }
    /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */ static parseFormatForOpts(formatOpts, localeOpts = {}) {
        const tokenList = (0, $kdX7T.formatOptsToTokens)(formatOpts, (0, $hi2rW.default).fromObject(localeOpts));
        return !tokenList ? null : tokenList.map((t)=>t ? t.val : null).join("");
    }
    /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */ static expandFormat(fmt, localeOpts = {}) {
        const expanded = (0, $kdX7T.expandMacroTokens)((0, $2lprD.default).parseFormat(fmt), (0, $hi2rW.default).fromObject(localeOpts));
        return expanded.map((t)=>t.val).join("");
    }
    static resetCache() {
        $8664b4a97d8239ef$var$zoneOffsetTs = undefined;
        $8664b4a97d8239ef$var$zoneOffsetGuessCache = {};
    }
    // INFO
    /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */ get(unit) {
        return this[unit];
    }
    /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */ get isValid() {
        return this.invalid === null;
    }
    /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */ get invalidReason() {
        return this.invalid ? this.invalid.reason : null;
    }
    /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */ get invalidExplanation() {
        return this.invalid ? this.invalid.explanation : null;
    }
    /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */ get locale() {
        return this.isValid ? this.loc.locale : null;
    }
    /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */ get numberingSystem() {
        return this.isValid ? this.loc.numberingSystem : null;
    }
    /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */ get outputCalendar() {
        return this.isValid ? this.loc.outputCalendar : null;
    }
    /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */ get zone() {
        return this._zone;
    }
    /**
   * Get the name of the time zone.
   * @type {string}
   */ get zoneName() {
        return this.isValid ? this.zone.name : null;
    }
    /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */ get year() {
        return this.isValid ? this.c.year : NaN;
    }
    /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */ get quarter() {
        return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
    }
    /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */ get month() {
        return this.isValid ? this.c.month : NaN;
    }
    /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */ get day() {
        return this.isValid ? this.c.day : NaN;
    }
    /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */ get hour() {
        return this.isValid ? this.c.hour : NaN;
    }
    /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */ get minute() {
        return this.isValid ? this.c.minute : NaN;
    }
    /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */ get second() {
        return this.isValid ? this.c.second : NaN;
    }
    /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */ get millisecond() {
        return this.isValid ? this.c.millisecond : NaN;
    }
    /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */ get weekYear() {
        return this.isValid ? $8664b4a97d8239ef$var$possiblyCachedWeekData(this).weekYear : NaN;
    }
    /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */ get weekNumber() {
        return this.isValid ? $8664b4a97d8239ef$var$possiblyCachedWeekData(this).weekNumber : NaN;
    }
    /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */ get weekday() {
        return this.isValid ? $8664b4a97d8239ef$var$possiblyCachedWeekData(this).weekday : NaN;
    }
    /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */ get isWeekend() {
        return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
    }
    /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */ get localWeekday() {
        return this.isValid ? $8664b4a97d8239ef$var$possiblyCachedLocalWeekData(this).weekday : NaN;
    }
    /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */ get localWeekNumber() {
        return this.isValid ? $8664b4a97d8239ef$var$possiblyCachedLocalWeekData(this).weekNumber : NaN;
    }
    /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */ get localWeekYear() {
        return this.isValid ? $8664b4a97d8239ef$var$possiblyCachedLocalWeekData(this).weekYear : NaN;
    }
    /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */ get ordinal() {
        return this.isValid ? (0, $70NWa.gregorianToOrdinal)(this.c).ordinal : NaN;
    }
    /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */ get monthShort() {
        return this.isValid ? (0, $s4LIV.default).months("short", {
            locObj: this.loc
        })[this.month - 1] : null;
    }
    /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */ get monthLong() {
        return this.isValid ? (0, $s4LIV.default).months("long", {
            locObj: this.loc
        })[this.month - 1] : null;
    }
    /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */ get weekdayShort() {
        return this.isValid ? (0, $s4LIV.default).weekdays("short", {
            locObj: this.loc
        })[this.weekday - 1] : null;
    }
    /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */ get weekdayLong() {
        return this.isValid ? (0, $s4LIV.default).weekdays("long", {
            locObj: this.loc
        })[this.weekday - 1] : null;
    }
    /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */ get offset() {
        return this.isValid ? +this.o : NaN;
    }
    /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */ get offsetNameShort() {
        if (this.isValid) return this.zone.offsetName(this.ts, {
            format: "short",
            locale: this.locale
        });
        else return null;
    }
    /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */ get offsetNameLong() {
        if (this.isValid) return this.zone.offsetName(this.ts, {
            format: "long",
            locale: this.locale
        });
        else return null;
    }
    /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */ get isOffsetFixed() {
        return this.isValid ? this.zone.isUniversal : null;
    }
    /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */ get isInDST() {
        if (this.isOffsetFixed) return false;
        else return this.offset > this.set({
            month: 1,
            day: 1
        }).offset || this.offset > this.set({
            month: 5
        }).offset;
    }
    /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */ getPossibleOffsets() {
        if (!this.isValid || this.isOffsetFixed) return [
            this
        ];
        const dayMs = 86400000;
        const minuteMs = 60000;
        const localTS = (0, $8XfCP.objToLocalTS)(this.c);
        const oEarlier = this.zone.offset(localTS - dayMs);
        const oLater = this.zone.offset(localTS + dayMs);
        const o1 = this.zone.offset(localTS - oEarlier * minuteMs);
        const o2 = this.zone.offset(localTS - oLater * minuteMs);
        if (o1 === o2) return [
            this
        ];
        const ts1 = localTS - o1 * minuteMs;
        const ts2 = localTS - o2 * minuteMs;
        const c1 = $8664b4a97d8239ef$var$tsToObj(ts1, o1);
        const c2 = $8664b4a97d8239ef$var$tsToObj(ts2, o2);
        if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) return [
            $8664b4a97d8239ef$var$clone(this, {
                ts: ts1
            }),
            $8664b4a97d8239ef$var$clone(this, {
                ts: ts2
            })
        ];
        return [
            this
        ];
    }
    /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */ get isInLeapYear() {
        return (0, $8XfCP.isLeapYear)(this.year);
    }
    /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */ get daysInMonth() {
        return (0, $8XfCP.daysInMonth)(this.year, this.month);
    }
    /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */ get daysInYear() {
        return this.isValid ? (0, $8XfCP.daysInYear)(this.year) : NaN;
    }
    /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */ get weeksInWeekYear() {
        return this.isValid ? (0, $8XfCP.weeksInWeekYear)(this.weekYear) : NaN;
    }
    /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */ get weeksInLocalWeekYear() {
        return this.isValid ? (0, $8XfCP.weeksInWeekYear)(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
    }
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ resolvedLocaleOptions(opts = {}) {
        const { locale: locale, numberingSystem: numberingSystem, calendar: calendar } = (0, $2lprD.default).create(this.loc.clone(opts), opts).resolvedOptions(this);
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    }
    // TRANSFORM
    /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */ toUTC(offset = 0, opts = {}) {
        return this.setZone((0, $2S7RT.default).instance(offset), opts);
    }
    /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */ toLocal() {
        return this.setZone((0, $h0abM.default).defaultZone);
    }
    /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */ setZone(zone, { keepLocalTime: keepLocalTime = false, keepCalendarTime: keepCalendarTime = false } = {}) {
        zone = (0, $fcA62.normalizeZone)(zone, (0, $h0abM.default).defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return $8664b4a97d8239ef$export$2e2bcd8739ae039.invalid($8664b4a97d8239ef$var$unsupportedZone(zone));
        else {
            let newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                const offsetGuess = zone.offset(this.ts);
                const asObj = this.toObject();
                [newTS] = $8664b4a97d8239ef$var$objToTS(asObj, offsetGuess, zone);
            }
            return $8664b4a97d8239ef$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    }
    /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */ reconfigure({ locale: locale, numberingSystem: numberingSystem, outputCalendar: outputCalendar } = {}) {
        const loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $8664b4a97d8239ef$var$clone(this, {
            loc: loc
        });
    }
    /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */ setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    }
    /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */ set(values) {
        if (!this.isValid) return this;
        const normalized = (0, $8XfCP.normalizeObject)(values, $8664b4a97d8239ef$var$normalizeUnitWithLocalWeeks);
        const { minDaysInFirstWeek: minDaysInFirstWeek, startOfWeek: startOfWeek } = (0, $70NWa.usesLocalWeekValues)(normalized, this.loc);
        const settingWeekStuff = !(0, $8XfCP.isUndefined)(normalized.weekYear) || !(0, $8XfCP.isUndefined)(normalized.weekNumber) || !(0, $8XfCP.isUndefined)(normalized.weekday), containsOrdinal = !(0, $8XfCP.isUndefined)(normalized.ordinal), containsGregorYear = !(0, $8XfCP.isUndefined)(normalized.year), containsGregorMD = !(0, $8XfCP.isUndefined)(normalized.month) || !(0, $8XfCP.isUndefined)(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new (0, $4vuXU.ConflictingSpecificationError)("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new (0, $4vuXU.ConflictingSpecificationError)("Can't mix ordinal dates with month/day");
        let mixed;
        if (settingWeekStuff) mixed = (0, $70NWa.weekToGregorian)({
            ...(0, $70NWa.gregorianToWeek)(this.c, minDaysInFirstWeek, startOfWeek),
            ...normalized
        }, minDaysInFirstWeek, startOfWeek);
        else if (!(0, $8XfCP.isUndefined)(normalized.ordinal)) mixed = (0, $70NWa.ordinalToGregorian)({
            ...(0, $70NWa.gregorianToOrdinal)(this.c),
            ...normalized
        });
        else {
            mixed = {
                ...this.toObject(),
                ...normalized
            };
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ((0, $8XfCP.isUndefined)(normalized.day)) mixed.day = Math.min((0, $8XfCP.daysInMonth)(mixed.year, mixed.month), mixed.day);
        }
        const [ts, o] = $8664b4a97d8239ef$var$objToTS(mixed, this.o, this.zone);
        return $8664b4a97d8239ef$var$clone(this, {
            ts: ts,
            o: o
        });
    }
    /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */ plus(duration) {
        if (!this.isValid) return this;
        const dur = (0, $fptYk.default).fromDurationLike(duration);
        return $8664b4a97d8239ef$var$clone(this, $8664b4a97d8239ef$var$adjustTime(this, dur));
    }
    /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */ minus(duration) {
        if (!this.isValid) return this;
        const dur = (0, $fptYk.default).fromDurationLike(duration).negate();
        return $8664b4a97d8239ef$var$clone(this, $8664b4a97d8239ef$var$adjustTime(this, dur));
    }
    /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */ startOf(unit, { useLocaleWeeks: useLocaleWeeks = false } = {}) {
        if (!this.isValid) return this;
        const o = {}, normalizedUnit = (0, $fptYk.default).normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
            case "milliseconds":
                break;
        }
        if (normalizedUnit === "weeks") {
            if (useLocaleWeeks) {
                const startOfWeek = this.loc.getStartOfWeek();
                const { weekday: weekday } = this;
                if (weekday < startOfWeek) o.weekNumber = this.weekNumber - 1;
                o.weekday = startOfWeek;
            } else o.weekday = 1;
        }
        if (normalizedUnit === "quarters") {
            const q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    }
    /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */ endOf(unit, opts) {
        return this.isValid ? this.plus({
            [unit]: 1
        }).startOf(unit, opts).minus(1) : this;
    }
    // OUTPUT
    /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */ toFormat(fmt, opts = {}) {
        return this.isValid ? (0, $2lprD.default).create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $8664b4a97d8239ef$var$INVALID;
    }
    /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */ toLocaleString(formatOpts = $9BxO1.DATE_SHORT, opts = {}) {
        return this.isValid ? (0, $2lprD.default).create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $8664b4a97d8239ef$var$INVALID;
    }
    /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */ toLocaleParts(opts = {}) {
        return this.isValid ? (0, $2lprD.default).create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */ toISO({ format: format = "extended", suppressSeconds: suppressSeconds = false, suppressMilliseconds: suppressMilliseconds = false, includeOffset: includeOffset = true, extendedZone: extendedZone = false } = {}) {
        if (!this.isValid) return null;
        const ext = format === "extended";
        let c = $8664b4a97d8239ef$var$toISODate(this, ext);
        c += "T";
        c += $8664b4a97d8239ef$var$toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
        return c;
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */ toISODate({ format: format = "extended" } = {}) {
        if (!this.isValid) return null;
        return $8664b4a97d8239ef$var$toISODate(this, format === "extended");
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */ toISOWeekDate() {
        return $8664b4a97d8239ef$var$toTechFormat(this, "kkkk-'W'WW-c");
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */ toISOTime({ suppressMilliseconds: suppressMilliseconds = false, suppressSeconds: suppressSeconds = false, includeOffset: includeOffset = true, includePrefix: includePrefix = false, extendedZone: extendedZone = false, format: format = "extended" } = {}) {
        if (!this.isValid) return null;
        let c = includePrefix ? "T" : "";
        return c + $8664b4a97d8239ef$var$toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    }
    /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */ toRFC2822() {
        return $8664b4a97d8239ef$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */ toHTTP() {
        return $8664b4a97d8239ef$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */ toSQLDate() {
        if (!this.isValid) return null;
        return $8664b4a97d8239ef$var$toISODate(this, true);
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */ toSQLTime({ includeOffset: includeOffset = true, includeZone: includeZone = false, includeOffsetSpace: includeOffsetSpace = true } = {}) {
        let fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $8664b4a97d8239ef$var$toTechFormat(this, fmt, true);
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */ toSQL(opts = {}) {
        if (!this.isValid) return null;
        return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
    }
    /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */ toString() {
        return this.isValid ? this.toISO() : $8664b4a97d8239ef$var$INVALID;
    }
    /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */ [Symbol.for("nodejs.util.inspect.custom")]() {
        if (this.isValid) return `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }`;
        else return `DateTime { Invalid, reason: ${this.invalidReason} }`;
    }
    /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */ valueOf() {
        return this.toMillis();
    }
    /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */ toMillis() {
        return this.isValid ? this.ts : NaN;
    }
    /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */ toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    }
    /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */ toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    }
    /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */ toJSON() {
        return this.toISO();
    }
    /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */ toBSON() {
        return this.toJSDate();
    }
    /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */ toObject(opts = {}) {
        if (!this.isValid) return {};
        const base = {
            ...this.c
        };
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    }
    /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */ toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    }
    // COMPARE
    /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */ diff(otherDateTime, unit = "milliseconds", opts = {}) {
        if (!this.isValid || !otherDateTime.isValid) return (0, $fptYk.default).invalid("created by diffing an invalid DateTime");
        const durOpts = {
            locale: this.locale,
            numberingSystem: this.numberingSystem,
            ...opts
        };
        const units = (0, $8XfCP.maybeArray)(unit).map((0, $fptYk.default).normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = (0, $4Plx3.default)(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    }
    /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ diffNow(unit = "milliseconds", opts = {}) {
        return this.diff($8664b4a97d8239ef$export$2e2bcd8739ae039.now(), unit, opts);
    }
    /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */ until(otherDateTime) {
        return this.isValid ? (0, $crAXh.default).fromDateTimes(this, otherDateTime) : this;
    }
    /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */ hasSame(otherDateTime, unit, opts) {
        if (!this.isValid) return false;
        const inputMs = otherDateTime.valueOf();
        const adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
    }
    /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */ equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    }
    /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */ toRelative(options = {}) {
        if (!this.isValid) return null;
        const base = options.base || $8664b4a97d8239ef$export$2e2bcd8739ae039.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        let units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        let unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $8664b4a97d8239ef$var$diffRelative(base, this.plus(padding), {
            ...options,
            numeric: "always",
            units: units,
            unit: unit
        });
    }
    /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */ toRelativeCalendar(options = {}) {
        if (!this.isValid) return null;
        return $8664b4a97d8239ef$var$diffRelative(options.base || $8664b4a97d8239ef$export$2e2bcd8739ae039.fromObject({}, {
            zone: this.zone
        }), this, {
            ...options,
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        });
    }
    /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */ static min(...dateTimes) {
        if (!dateTimes.every($8664b4a97d8239ef$export$2e2bcd8739ae039.isDateTime)) throw new (0, $4vuXU.InvalidArgumentError)("min requires all arguments be DateTimes");
        return (0, $8XfCP.bestBy)(dateTimes, (i)=>i.valueOf(), Math.min);
    }
    /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */ static max(...dateTimes) {
        if (!dateTimes.every($8664b4a97d8239ef$export$2e2bcd8739ae039.isDateTime)) throw new (0, $4vuXU.InvalidArgumentError)("max requires all arguments be DateTimes");
        return (0, $8XfCP.bestBy)(dateTimes, (i)=>i.valueOf(), Math.max);
    }
    // MISC
    /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */ static fromFormatExplain(text, fmt, options = {}) {
        const { locale: locale = null, numberingSystem: numberingSystem = null } = options, localeToUse = (0, $hi2rW.default).fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return (0, $kdX7T.explainFromTokens)(localeToUse, text, fmt);
    }
    /**
   * @deprecated use fromFormatExplain instead
   */ static fromStringExplain(text, fmt, options = {}) {
        return $8664b4a97d8239ef$export$2e2bcd8739ae039.fromFormatExplain(text, fmt, options);
    }
    /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */ static buildFormatParser(fmt, options = {}) {
        const { locale: locale = null, numberingSystem: numberingSystem = null } = options, localeToUse = (0, $hi2rW.default).fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return new (0, $kdX7T.TokenParser)(localeToUse, fmt);
    }
    /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */ static fromFormatParser(text, formatParser, opts = {}) {
        if ((0, $8XfCP.isUndefined)(text) || (0, $8XfCP.isUndefined)(formatParser)) throw new (0, $4vuXU.InvalidArgumentError)("fromFormatParser requires an input string and a format parser");
        const { locale: locale = null, numberingSystem: numberingSystem = null } = opts, localeToUse = (0, $hi2rW.default).fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        if (!localeToUse.equals(formatParser.locale)) throw new (0, $4vuXU.InvalidArgumentError)(`fromFormatParser called with a locale of ${localeToUse}, ` + `but the format parser was created for ${formatParser.locale}`);
        const { result: result, zone: zone, specificOffset: specificOffset, invalidReason: invalidReason } = formatParser.explainFromTokens(text);
        if (invalidReason) return $8664b4a97d8239ef$export$2e2bcd8739ae039.invalid(invalidReason);
        else return $8664b4a97d8239ef$var$parseDataToDateTime(result, zone, opts, `format ${formatParser.format}`, text, specificOffset);
    }
    // FORMAT PRESETS
    /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */ static get DATE_SHORT() {
        return $9BxO1.DATE_SHORT;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */ static get DATE_MED() {
        return $9BxO1.DATE_MED;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */ static get DATE_MED_WITH_WEEKDAY() {
        return $9BxO1.DATE_MED_WITH_WEEKDAY;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */ static get DATE_FULL() {
        return $9BxO1.DATE_FULL;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */ static get DATE_HUGE() {
        return $9BxO1.DATE_HUGE;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_SIMPLE() {
        return $9BxO1.TIME_SIMPLE;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_WITH_SECONDS() {
        return $9BxO1.TIME_WITH_SECONDS;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_WITH_SHORT_OFFSET() {
        return $9BxO1.TIME_WITH_SHORT_OFFSET;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_WITH_LONG_OFFSET() {
        return $9BxO1.TIME_WITH_LONG_OFFSET;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */ static get TIME_24_SIMPLE() {
        return $9BxO1.TIME_24_SIMPLE;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */ static get TIME_24_WITH_SECONDS() {
        return $9BxO1.TIME_24_WITH_SECONDS;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */ static get TIME_24_WITH_SHORT_OFFSET() {
        return $9BxO1.TIME_24_WITH_SHORT_OFFSET;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */ static get TIME_24_WITH_LONG_OFFSET() {
        return $9BxO1.TIME_24_WITH_LONG_OFFSET;
    }
    /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_SHORT() {
        return $9BxO1.DATETIME_SHORT;
    }
    /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_SHORT_WITH_SECONDS() {
        return $9BxO1.DATETIME_SHORT_WITH_SECONDS;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_MED() {
        return $9BxO1.DATETIME_MED;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_MED_WITH_SECONDS() {
        return $9BxO1.DATETIME_MED_WITH_SECONDS;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_MED_WITH_WEEKDAY() {
        return $9BxO1.DATETIME_MED_WITH_WEEKDAY;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_FULL() {
        return $9BxO1.DATETIME_FULL;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_FULL_WITH_SECONDS() {
        return $9BxO1.DATETIME_FULL_WITH_SECONDS;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_HUGE() {
        return $9BxO1.DATETIME_HUGE;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_HUGE_WITH_SECONDS() {
        return $9BxO1.DATETIME_HUGE_WITH_SECONDS;
    }
}
function $8664b4a97d8239ef$export$d207855dff529fc9(dateTimeish) {
    if ($8664b4a97d8239ef$export$2e2bcd8739ae039.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && (0, $8XfCP.isNumber)(dateTimeish.valueOf())) return $8664b4a97d8239ef$export$2e2bcd8739ae039.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $8664b4a97d8239ef$export$2e2bcd8739ae039.fromObject(dateTimeish);
    else throw new (0, $4vuXU.InvalidArgumentError)(`Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`);
}

});
parcelRegister("fptYk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b38070a8eaf8c985$export$2e2bcd8739ae039);

var $4vuXU = parcelRequire("4vuXU");

var $2lprD = parcelRequire("2lprD");

var $f6Tt7 = parcelRequire("f6Tt7");

var $hi2rW = parcelRequire("hi2rW");

var $jJizu = parcelRequire("jJizu");

var $8XfCP = parcelRequire("8XfCP");

var $h0abM = parcelRequire("h0abM");

var $bxn76 = parcelRequire("bxn76");
const $b38070a8eaf8c985$var$INVALID = "Invalid Duration";
const $b38070a8eaf8c985$export$b2b4559e62423d84 = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $b38070a8eaf8c985$export$66b25084afa3c725 = {
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    },
    ...$b38070a8eaf8c985$export$b2b4559e62423d84
}, $b38070a8eaf8c985$export$afca50ae33abd78b = 365.2425, $b38070a8eaf8c985$export$70cde7cbd78deec8 = 30.436875, $b38070a8eaf8c985$export$3a9e77e060440793 = {
    years: {
        quarters: 4,
        months: 12,
        weeks: $b38070a8eaf8c985$export$afca50ae33abd78b / 7,
        days: $b38070a8eaf8c985$export$afca50ae33abd78b,
        hours: $b38070a8eaf8c985$export$afca50ae33abd78b * 24,
        minutes: $b38070a8eaf8c985$export$afca50ae33abd78b * 1440,
        seconds: $b38070a8eaf8c985$export$afca50ae33abd78b * 86400,
        milliseconds: $b38070a8eaf8c985$export$afca50ae33abd78b * 86400000
    },
    quarters: {
        months: 3,
        weeks: $b38070a8eaf8c985$export$afca50ae33abd78b / 28,
        days: $b38070a8eaf8c985$export$afca50ae33abd78b / 4,
        hours: $b38070a8eaf8c985$export$afca50ae33abd78b * 24 / 4,
        minutes: $b38070a8eaf8c985$export$afca50ae33abd78b * 1440 / 4,
        seconds: $b38070a8eaf8c985$export$afca50ae33abd78b * 86400 / 4,
        milliseconds: $b38070a8eaf8c985$export$afca50ae33abd78b * 86400000 / 4
    },
    months: {
        weeks: $b38070a8eaf8c985$export$70cde7cbd78deec8 / 7,
        days: $b38070a8eaf8c985$export$70cde7cbd78deec8,
        hours: $b38070a8eaf8c985$export$70cde7cbd78deec8 * 24,
        minutes: $b38070a8eaf8c985$export$70cde7cbd78deec8 * 1440,
        seconds: $b38070a8eaf8c985$export$70cde7cbd78deec8 * 86400,
        milliseconds: $b38070a8eaf8c985$export$70cde7cbd78deec8 * 86400000
    },
    ...$b38070a8eaf8c985$export$b2b4559e62423d84
};
// units ordered by size
const $b38070a8eaf8c985$var$orderedUnits = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
const $b38070a8eaf8c985$var$reverseUnits = $b38070a8eaf8c985$var$orderedUnits.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function $b38070a8eaf8c985$var$clone(dur, alts, clear = false) {
    // deep merge for vals
    const conf = {
        values: clear ? alts.values : {
            ...dur.values,
            ...alts.values || {}
        },
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new $b38070a8eaf8c985$export$2e2bcd8739ae039(conf);
}
function $b38070a8eaf8c985$var$durationToMillis(matrix, vals) {
    let sum = vals.milliseconds ?? 0;
    for (const unit of $b38070a8eaf8c985$var$reverseUnits.slice(1))if (vals[unit]) sum += vals[unit] * matrix[unit]["milliseconds"];
    return sum;
}
// NB: mutates parameters
function $b38070a8eaf8c985$var$normalizeValues(matrix, vals) {
    // the logic below assumes the overall value of the duration is positive
    // if this is not the case, factor is used to make it so
    const factor = $b38070a8eaf8c985$var$durationToMillis(matrix, vals) < 0 ? -1 : 1;
    $b38070a8eaf8c985$var$orderedUnits.reduceRight((previous, current)=>{
        if (!(0, $8XfCP.isUndefined)(vals[current])) {
            if (previous) {
                const previousVal = vals[previous] * factor;
                const conv = matrix[current][previous];
                // if (previousVal < 0):
                // lower order unit is negative (e.g. { years: 2, days: -2 })
                // normalize this by reducing the higher order unit by the appropriate amount
                // and increasing the lower order unit
                // this can never make the higher order unit negative, because this function only operates
                // on positive durations, so the amount of time represented by the lower order unit cannot
                // be larger than the higher order unit
                // else:
                // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
                // in this case we attempt to convert as much as possible from the lower order unit into
                // the higher order one
                //
                // Math.floor takes care of both of these cases, rounding away from 0
                // if previousVal < 0 it makes the absolute value larger
                // if previousVal >= it makes the absolute value smaller
                const rollUp = Math.floor(previousVal / conv);
                vals[current] += rollUp * factor;
                vals[previous] -= rollUp * conv * factor;
            }
            return current;
        } else return previous;
    }, null);
    // try to convert any decimals into smaller units if possible
    // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
    $b38070a8eaf8c985$var$orderedUnits.reduce((previous, current)=>{
        if (!(0, $8XfCP.isUndefined)(vals[current])) {
            if (previous) {
                const fraction = vals[previous] % 1;
                vals[previous] -= fraction;
                vals[current] += fraction * matrix[previous][current];
            }
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function $b38070a8eaf8c985$var$removeZeroes(vals) {
    const newVals = {};
    for (const [key, value] of Object.entries(vals))if (value !== 0) newVals[key] = value;
    return newVals;
}
class $b38070a8eaf8c985$export$2e2bcd8739ae039 {
    /**
   * @private
   */ constructor(config){
        const accurate = config.conversionAccuracy === "longterm" || false;
        let matrix = accurate ? $b38070a8eaf8c985$export$3a9e77e060440793 : $b38070a8eaf8c985$export$66b25084afa3c725;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || (0, $hi2rW.default).create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ static fromMillis(count, opts) {
        return $b38070a8eaf8c985$export$2e2bcd8739ae039.fromObject({
            milliseconds: count
        }, opts);
    }
    /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */ static fromObject(obj, opts = {}) {
        if (obj == null || typeof obj !== "object") throw new (0, $4vuXU.InvalidArgumentError)(`Duration.fromObject: argument expected to be an object, got ${obj === null ? "null" : typeof obj}`);
        return new $b38070a8eaf8c985$export$2e2bcd8739ae039({
            values: (0, $8XfCP.normalizeObject)(obj, $b38070a8eaf8c985$export$2e2bcd8739ae039.normalizeUnit),
            loc: (0, $hi2rW.default).fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    }
    /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */ static fromDurationLike(durationLike) {
        if ((0, $8XfCP.isNumber)(durationLike)) return $b38070a8eaf8c985$export$2e2bcd8739ae039.fromMillis(durationLike);
        else if ($b38070a8eaf8c985$export$2e2bcd8739ae039.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return $b38070a8eaf8c985$export$2e2bcd8739ae039.fromObject(durationLike);
        else throw new (0, $4vuXU.InvalidArgumentError)(`Unknown duration argument ${durationLike} of type ${typeof durationLike}`);
    }
    /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */ static fromISO(text, opts) {
        const [parsed] = (0, $jJizu.parseISODuration)(text);
        if (parsed) return $b38070a8eaf8c985$export$2e2bcd8739ae039.fromObject(parsed, opts);
        else return $b38070a8eaf8c985$export$2e2bcd8739ae039.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
    /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */ static fromISOTime(text, opts) {
        const [parsed] = (0, $jJizu.parseISOTimeOnly)(text);
        if (parsed) return $b38070a8eaf8c985$export$2e2bcd8739ae039.fromObject(parsed, opts);
        else return $b38070a8eaf8c985$export$2e2bcd8739ae039.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
    /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */ static invalid(reason, explanation = null) {
        if (!reason) throw new (0, $4vuXU.InvalidArgumentError)("need to specify a reason the Duration is invalid");
        const invalid = reason instanceof (0, $f6Tt7.default) ? reason : new (0, $f6Tt7.default)(reason, explanation);
        if ((0, $h0abM.default).throwOnInvalid) throw new (0, $4vuXU.InvalidDurationError)(invalid);
        else return new $b38070a8eaf8c985$export$2e2bcd8739ae039({
            invalid: invalid
        });
    }
    /**
   * @private
   */ static normalizeUnit(unit) {
        const normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new (0, $4vuXU.InvalidUnitError)(unit);
        return normalized;
    }
    /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ static isDuration(o) {
        return o && o.isLuxonDuration || false;
    }
    /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */ get locale() {
        return this.isValid ? this.loc.locale : null;
    }
    /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */ get numberingSystem() {
        return this.isValid ? this.loc.numberingSystem : null;
    }
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */ toFormat(fmt, opts = {}) {
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        const fmtOpts = {
            ...opts,
            floor: opts.round !== false && opts.floor !== false
        };
        return this.isValid ? (0, $2lprD.default).create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $b38070a8eaf8c985$var$INVALID;
    }
    /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */ toHuman(opts = {}) {
        if (!this.isValid) return $b38070a8eaf8c985$var$INVALID;
        const l = $b38070a8eaf8c985$var$orderedUnits.map((unit)=>{
            const val = this.values[unit];
            if ((0, $8XfCP.isUndefined)(val)) return null;
            return this.loc.numberFormatter({
                style: "unit",
                unitDisplay: "long",
                ...opts,
                unit: unit.slice(0, -1)
            }).format(val);
        }).filter((n)=>n);
        return this.loc.listFormatter({
            type: "conjunction",
            style: opts.listStyle || "narrow",
            ...opts
        }).format(l);
    }
    /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */ toObject() {
        if (!this.isValid) return {};
        return {
            ...this.values
        };
    }
    /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */ toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        let s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += (0, $8XfCP.roundTo)(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    }
    /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */ toISOTime(opts = {}) {
        if (!this.isValid) return null;
        const millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = {
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended",
            ...opts,
            includeOffset: false
        };
        const dateTime = (0, $bxn76.default).fromMillis(millis, {
            zone: "UTC"
        });
        return dateTime.toISOTime(opts);
    }
    /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */ toJSON() {
        return this.toISO();
    }
    /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */ toString() {
        return this.toISO();
    }
    /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */ [Symbol.for("nodejs.util.inspect.custom")]() {
        if (this.isValid) return `Duration { values: ${JSON.stringify(this.values)} }`;
        else return `Duration { Invalid, reason: ${this.invalidReason} }`;
    }
    /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */ toMillis() {
        if (!this.isValid) return NaN;
        return $b38070a8eaf8c985$var$durationToMillis(this.matrix, this.values);
    }
    /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */ valueOf() {
        return this.toMillis();
    }
    /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ plus(duration) {
        if (!this.isValid) return this;
        const dur = $b38070a8eaf8c985$export$2e2bcd8739ae039.fromDurationLike(duration), result = {};
        for (const k of $b38070a8eaf8c985$var$orderedUnits)if ((0, $8XfCP.hasOwnProperty)(dur.values, k) || (0, $8XfCP.hasOwnProperty)(this.values, k)) result[k] = dur.get(k) + this.get(k);
        return $b38070a8eaf8c985$var$clone(this, {
            values: result
        }, true);
    }
    /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ minus(duration) {
        if (!this.isValid) return this;
        const dur = $b38070a8eaf8c985$export$2e2bcd8739ae039.fromDurationLike(duration);
        return this.plus(dur.negate());
    }
    /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */ mapUnits(fn) {
        if (!this.isValid) return this;
        const result = {};
        for (const k of Object.keys(this.values))result[k] = (0, $8XfCP.asNumber)(fn(this.values[k], k));
        return $b38070a8eaf8c985$var$clone(this, {
            values: result
        }, true);
    }
    /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */ get(unit) {
        return this[$b38070a8eaf8c985$export$2e2bcd8739ae039.normalizeUnit(unit)];
    }
    /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */ set(values) {
        if (!this.isValid) return this;
        const mixed = {
            ...this.values,
            ...(0, $8XfCP.normalizeObject)(values, $b38070a8eaf8c985$export$2e2bcd8739ae039.normalizeUnit)
        };
        return $b38070a8eaf8c985$var$clone(this, {
            values: mixed
        });
    }
    /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */ reconfigure({ locale: locale, numberingSystem: numberingSystem, conversionAccuracy: conversionAccuracy, matrix: matrix } = {}) {
        const loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        });
        const opts = {
            loc: loc,
            matrix: matrix,
            conversionAccuracy: conversionAccuracy
        };
        return $b38070a8eaf8c985$var$clone(this, opts);
    }
    /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */ as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    }
    /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */ normalize() {
        if (!this.isValid) return this;
        const vals = this.toObject();
        $b38070a8eaf8c985$var$normalizeValues(this.matrix, vals);
        return $b38070a8eaf8c985$var$clone(this, {
            values: vals
        }, true);
    }
    /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */ rescale() {
        if (!this.isValid) return this;
        const vals = $b38070a8eaf8c985$var$removeZeroes(this.normalize().shiftToAll().toObject());
        return $b38070a8eaf8c985$var$clone(this, {
            values: vals
        }, true);
    }
    /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */ shiftTo(...units) {
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map((u)=>$b38070a8eaf8c985$export$2e2bcd8739ae039.normalizeUnit(u));
        const built = {}, accumulated = {}, vals = this.toObject();
        let lastUnit;
        for (const k of $b38070a8eaf8c985$var$orderedUnits){
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                let own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(const ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if ((0, $8XfCP.isNumber)(vals[k])) own += vals[k];
                // only keep the integer part for now in the hopes of putting any decimal part
                // into a smaller unit later
                const i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
            // otherwise, keep it in the wings to boil it later
            } else if ((0, $8XfCP.isNumber)(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(const key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        $b38070a8eaf8c985$var$normalizeValues(this.matrix, built);
        return $b38070a8eaf8c985$var$clone(this, {
            values: built
        }, true);
    }
    /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */ shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    }
    /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */ negate() {
        if (!this.isValid) return this;
        const negated = {};
        for (const k of Object.keys(this.values))negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        return $b38070a8eaf8c985$var$clone(this, {
            values: negated
        }, true);
    }
    /**
   * Get the years.
   * @type {number}
   */ get years() {
        return this.isValid ? this.values.years || 0 : NaN;
    }
    /**
   * Get the quarters.
   * @type {number}
   */ get quarters() {
        return this.isValid ? this.values.quarters || 0 : NaN;
    }
    /**
   * Get the months.
   * @type {number}
   */ get months() {
        return this.isValid ? this.values.months || 0 : NaN;
    }
    /**
   * Get the weeks
   * @type {number}
   */ get weeks() {
        return this.isValid ? this.values.weeks || 0 : NaN;
    }
    /**
   * Get the days.
   * @type {number}
   */ get days() {
        return this.isValid ? this.values.days || 0 : NaN;
    }
    /**
   * Get the hours.
   * @type {number}
   */ get hours() {
        return this.isValid ? this.values.hours || 0 : NaN;
    }
    /**
   * Get the minutes.
   * @type {number}
   */ get minutes() {
        return this.isValid ? this.values.minutes || 0 : NaN;
    }
    /**
   * Get the seconds.
   * @return {number}
   */ get seconds() {
        return this.isValid ? this.values.seconds || 0 : NaN;
    }
    /**
   * Get the milliseconds.
   * @return {number}
   */ get milliseconds() {
        return this.isValid ? this.values.milliseconds || 0 : NaN;
    }
    /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */ get isValid() {
        return this.invalid === null;
    }
    /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */ get invalidReason() {
        return this.invalid ? this.invalid.reason : null;
    }
    /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */ get invalidExplanation() {
        return this.invalid ? this.invalid.explanation : null;
    }
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for (const u of $b38070a8eaf8c985$var$orderedUnits){
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    }
}

});
parcelRegister("4vuXU", function(module, exports) {

$parcel$export(module.exports, "InvalidDateTimeError", () => $348213be7ff9e066$export$aaeef2cf7fd7967f);
$parcel$export(module.exports, "InvalidIntervalError", () => $348213be7ff9e066$export$cdb4559f04a244ae);
$parcel$export(module.exports, "InvalidDurationError", () => $348213be7ff9e066$export$fa63917b8416fe36);
$parcel$export(module.exports, "ConflictingSpecificationError", () => $348213be7ff9e066$export$10234d3be7f66e6a);
$parcel$export(module.exports, "InvalidUnitError", () => $348213be7ff9e066$export$ac94f561e2d387b4);
$parcel$export(module.exports, "InvalidArgumentError", () => $348213be7ff9e066$export$9c711d4a95378233);
$parcel$export(module.exports, "ZoneIsAbstractError", () => $348213be7ff9e066$export$b0a664b8a649f992);
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ class $348213be7ff9e066$var$LuxonError extends Error {
}
class $348213be7ff9e066$export$aaeef2cf7fd7967f extends $348213be7ff9e066$var$LuxonError {
    constructor(reason){
        super(`Invalid DateTime: ${reason.toMessage()}`);
    }
}
class $348213be7ff9e066$export$cdb4559f04a244ae extends $348213be7ff9e066$var$LuxonError {
    constructor(reason){
        super(`Invalid Interval: ${reason.toMessage()}`);
    }
}
class $348213be7ff9e066$export$fa63917b8416fe36 extends $348213be7ff9e066$var$LuxonError {
    constructor(reason){
        super(`Invalid Duration: ${reason.toMessage()}`);
    }
}
class $348213be7ff9e066$export$10234d3be7f66e6a extends $348213be7ff9e066$var$LuxonError {
}
class $348213be7ff9e066$export$ac94f561e2d387b4 extends $348213be7ff9e066$var$LuxonError {
    constructor(unit){
        super(`Invalid unit ${unit}`);
    }
}
class $348213be7ff9e066$export$9c711d4a95378233 extends $348213be7ff9e066$var$LuxonError {
}
class $348213be7ff9e066$export$b0a664b8a649f992 extends $348213be7ff9e066$var$LuxonError {
    constructor(){
        super("Zone is an abstract class");
    }
}

});

parcelRegister("2lprD", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b5147b84a37a3f3$export$2e2bcd8739ae039);

var $81AKw = parcelRequire("81AKw");

var $9BxO1 = parcelRequire("9BxO1");

var $8XfCP = parcelRequire("8XfCP");
function $1b5147b84a37a3f3$var$stringifyTokens(splits, tokenToString) {
    let s = "";
    for (const token of splits)if (token.literal) s += token.val;
    else s += tokenToString(token.val);
    return s;
}
const $1b5147b84a37a3f3$var$macroTokenToFormatOpts = {
    D: $9BxO1.DATE_SHORT,
    DD: $9BxO1.DATE_MED,
    DDD: $9BxO1.DATE_FULL,
    DDDD: $9BxO1.DATE_HUGE,
    t: $9BxO1.TIME_SIMPLE,
    tt: $9BxO1.TIME_WITH_SECONDS,
    ttt: $9BxO1.TIME_WITH_SHORT_OFFSET,
    tttt: $9BxO1.TIME_WITH_LONG_OFFSET,
    T: $9BxO1.TIME_24_SIMPLE,
    TT: $9BxO1.TIME_24_WITH_SECONDS,
    TTT: $9BxO1.TIME_24_WITH_SHORT_OFFSET,
    TTTT: $9BxO1.TIME_24_WITH_LONG_OFFSET,
    f: $9BxO1.DATETIME_SHORT,
    ff: $9BxO1.DATETIME_MED,
    fff: $9BxO1.DATETIME_FULL,
    ffff: $9BxO1.DATETIME_HUGE,
    F: $9BxO1.DATETIME_SHORT_WITH_SECONDS,
    FF: $9BxO1.DATETIME_MED_WITH_SECONDS,
    FFF: $9BxO1.DATETIME_FULL_WITH_SECONDS,
    FFFF: $9BxO1.DATETIME_HUGE_WITH_SECONDS
};
class $1b5147b84a37a3f3$export$2e2bcd8739ae039 {
    static create(locale, opts = {}) {
        return new $1b5147b84a37a3f3$export$2e2bcd8739ae039(locale, opts);
    }
    static parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        let current = null, currentFull = "", bracketed = false;
        const splits = [];
        for(let i = 0; i < fmt.length; i++){
            const c = fmt.charAt(i);
            if (c === "'") {
                if (currentFull.length > 0) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    }
    static macroTokenToFormatOpts(token) {
        return $1b5147b84a37a3f3$var$macroTokenToFormatOpts[token];
    }
    constructor(locale, formatOpts){
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        const df = this.systemLoc.dtFormatter(dt, {
            ...this.opts,
            ...opts
        });
        return df.format();
    }
    dtFormatter(dt, opts = {}) {
        return this.loc.dtFormatter(dt, {
            ...this.opts,
            ...opts
        });
    }
    formatDateTime(dt, opts) {
        return this.dtFormatter(dt, opts).format();
    }
    formatDateTimeParts(dt, opts) {
        return this.dtFormatter(dt, opts).formatToParts();
    }
    formatInterval(interval, opts) {
        const df = this.dtFormatter(interval.start, opts);
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    }
    resolvedOptions(dt, opts) {
        return this.dtFormatter(dt, opts).resolvedOptions();
    }
    num(n, p = 0) {
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return (0, $8XfCP.padStart)(n, p);
        const opts = {
            ...this.opts
        };
        if (p > 0) opts.padTo = p;
        return this.loc.numberFormatter(opts).format(n);
    }
    formatDateTimeFromString(dt, fmt) {
        const knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = (opts, extract)=>this.loc.extract(dt, opts, extract), formatOffset = (opts)=>{
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = ()=>knownEnglish ? $81AKw.meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod"), month = (length, standalone)=>knownEnglish ? $81AKw.monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month"), weekday = (length, standalone)=>knownEnglish ? $81AKw.weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday"), maybeMacro = (token)=>{
            const formatOpts = $1b5147b84a37a3f3$export$2e2bcd8739ae039.macroTokenToFormatOpts(token);
            if (formatOpts) return this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = (length)=>knownEnglish ? $81AKw.eraForDateTime(dt, length) : string({
                era: length
            }, "era"), tokenToString = (token)=>{
            // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
            switch(token){
                // ms
                case "S":
                    return this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return this.num(dt.second);
                case "ss":
                    return this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return this.num(dt.minute);
                case "mm":
                    return this.num(dt.minute, 2);
                // hours
                case "h":
                    return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return this.num(dt.hour);
                case "HH":
                    return this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return this.num(dt.weekYear, 4);
                case "W":
                    return this.num(dt.weekNumber);
                case "WW":
                    return this.num(dt.weekNumber, 2);
                case "n":
                    return this.num(dt.localWeekNumber);
                case "nn":
                    return this.num(dt.localWeekNumber, 2);
                case "ii":
                    return this.num(dt.localWeekYear.toString().slice(-2), 2);
                case "iiii":
                    return this.num(dt.localWeekYear, 4);
                case "o":
                    return this.num(dt.ordinal);
                case "ooo":
                    return this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return this.num(dt.quarter);
                case "qq":
                    // like 01
                    return this.num(dt.quarter, 2);
                case "X":
                    return this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $1b5147b84a37a3f3$var$stringifyTokens($1b5147b84a37a3f3$export$2e2bcd8739ae039.parseFormat(fmt), tokenToString);
    }
    formatDurationFromString(dur, fmt) {
        const tokenToField = (token)=>{
            switch(token[0]){
                case "S":
                    return "millisecond";
                case "s":
                    return "second";
                case "m":
                    return "minute";
                case "h":
                    return "hour";
                case "d":
                    return "day";
                case "w":
                    return "week";
                case "M":
                    return "month";
                case "y":
                    return "year";
                default:
                    return null;
            }
        }, tokenToString = (lildur)=>(token)=>{
                const mapped = tokenToField(token);
                if (mapped) return this.num(lildur.get(mapped), token.length);
                else return token;
            }, tokens = $1b5147b84a37a3f3$export$2e2bcd8739ae039.parseFormat(fmt), realTokens = tokens.reduce((found, { literal: literal, val: val })=>literal ? found : found.concat(val), []), collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t)=>t));
        return $1b5147b84a37a3f3$var$stringifyTokens(tokens, tokenToString(collapsed));
    }
}

});
parcelRegister("81AKw", function(module, exports) {

$parcel$export(module.exports, "monthsShort", () => $5d7aec639bcea2c4$export$b4b23bfab2f68498);
$parcel$export(module.exports, "months", () => $5d7aec639bcea2c4$export$16352d1b10c5eb38);
$parcel$export(module.exports, "weekdaysLong", () => $5d7aec639bcea2c4$export$406f4855508be663);
$parcel$export(module.exports, "weekdaysShort", () => $5d7aec639bcea2c4$export$d89a20b736c12a21);
$parcel$export(module.exports, "weekdays", () => $5d7aec639bcea2c4$export$21e30707d27594c3);
$parcel$export(module.exports, "meridiems", () => $5d7aec639bcea2c4$export$94f480e07472beac);
$parcel$export(module.exports, "eras", () => $5d7aec639bcea2c4$export$41e043ce18349ee8);
$parcel$export(module.exports, "meridiemForDateTime", () => $5d7aec639bcea2c4$export$fbaec5aff3c47ddc);
$parcel$export(module.exports, "weekdayForDateTime", () => $5d7aec639bcea2c4$export$a48176098d281ad2);
$parcel$export(module.exports, "monthForDateTime", () => $5d7aec639bcea2c4$export$5d07d42a611abcf2);
$parcel$export(module.exports, "eraForDateTime", () => $5d7aec639bcea2c4$export$3394b151c30b498b);
$parcel$export(module.exports, "formatRelativeTime", () => $5d7aec639bcea2c4$export$b4ea3b48dcf921f6);

var $9BxO1 = parcelRequire("9BxO1");

var $8XfCP = parcelRequire("8XfCP");
function $5d7aec639bcea2c4$var$stringify(obj) {
    return JSON.stringify(obj, Object.keys(obj).sort());
}
const $5d7aec639bcea2c4$export$2bb3eb27682a776 = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const $5d7aec639bcea2c4$export$b4b23bfab2f68498 = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $5d7aec639bcea2c4$export$db1cae8e85a8ede0 = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $5d7aec639bcea2c4$export$16352d1b10c5eb38(length) {
    switch(length){
        case "narrow":
            return [
                ...$5d7aec639bcea2c4$export$db1cae8e85a8ede0
            ];
        case "short":
            return [
                ...$5d7aec639bcea2c4$export$b4b23bfab2f68498
            ];
        case "long":
            return [
                ...$5d7aec639bcea2c4$export$2bb3eb27682a776
            ];
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
const $5d7aec639bcea2c4$export$406f4855508be663 = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
const $5d7aec639bcea2c4$export$d89a20b736c12a21 = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
const $5d7aec639bcea2c4$export$2997fd2e8025c4fc = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $5d7aec639bcea2c4$export$21e30707d27594c3(length) {
    switch(length){
        case "narrow":
            return [
                ...$5d7aec639bcea2c4$export$2997fd2e8025c4fc
            ];
        case "short":
            return [
                ...$5d7aec639bcea2c4$export$d89a20b736c12a21
            ];
        case "long":
            return [
                ...$5d7aec639bcea2c4$export$406f4855508be663
            ];
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
const $5d7aec639bcea2c4$export$94f480e07472beac = [
    "AM",
    "PM"
];
const $5d7aec639bcea2c4$export$a3539dc50fc6cc47 = [
    "Before Christ",
    "Anno Domini"
];
const $5d7aec639bcea2c4$export$a8f63c83729947a4 = [
    "BC",
    "AD"
];
const $5d7aec639bcea2c4$export$2b0880176b7ca6fb = [
    "B",
    "A"
];
function $5d7aec639bcea2c4$export$41e043ce18349ee8(length) {
    switch(length){
        case "narrow":
            return [
                ...$5d7aec639bcea2c4$export$2b0880176b7ca6fb
            ];
        case "short":
            return [
                ...$5d7aec639bcea2c4$export$a8f63c83729947a4
            ];
        case "long":
            return [
                ...$5d7aec639bcea2c4$export$a3539dc50fc6cc47
            ];
        default:
            return null;
    }
}
function $5d7aec639bcea2c4$export$fbaec5aff3c47ddc(dt) {
    return $5d7aec639bcea2c4$export$94f480e07472beac[dt.hour < 12 ? 0 : 1];
}
function $5d7aec639bcea2c4$export$a48176098d281ad2(dt, length) {
    return $5d7aec639bcea2c4$export$21e30707d27594c3(length)[dt.weekday - 1];
}
function $5d7aec639bcea2c4$export$5d07d42a611abcf2(dt, length) {
    return $5d7aec639bcea2c4$export$16352d1b10c5eb38(length)[dt.month - 1];
}
function $5d7aec639bcea2c4$export$3394b151c30b498b(dt, length) {
    return $5d7aec639bcea2c4$export$41e043ce18349ee8(length)[dt.year < 0 ? 0 : 1];
}
function $5d7aec639bcea2c4$export$b4ea3b48dcf921f6(unit, count, numeric = "always", narrow = false) {
    const units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    const lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        const isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : `next ${units[unit][0]}`;
            case -1:
                return isDay ? "yesterday" : `last ${units[unit][0]}`;
            case 0:
                return isDay ? "today" : `this ${units[unit][0]}`;
            default:
        }
    }
    const isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}
function $5d7aec639bcea2c4$export$1aa7d7568ce4670d(knownFormat) {
    // these all have the offsets removed because we don't have access to them
    // without all the intl stuff this is backfilling
    const filtered = (0, $8XfCP.pick)(knownFormat, [
        "weekday",
        "era",
        "year",
        "month",
        "day",
        "hour",
        "minute",
        "second",
        "timeZoneName",
        "hourCycle"
    ]), key = $5d7aec639bcea2c4$var$stringify(filtered), dateTimeHuge = "EEEE, LLLL d, yyyy, h:mm a";
    switch(key){
        case $5d7aec639bcea2c4$var$stringify($9BxO1.DATE_SHORT):
            return "M/d/yyyy";
        case $5d7aec639bcea2c4$var$stringify($9BxO1.DATE_MED):
            return "LLL d, yyyy";
        case $5d7aec639bcea2c4$var$stringify($9BxO1.DATE_MED_WITH_WEEKDAY):
            return "EEE, LLL d, yyyy";
        case $5d7aec639bcea2c4$var$stringify($9BxO1.DATE_FULL):
            return "LLLL d, yyyy";
        case $5d7aec639bcea2c4$var$stringify($9BxO1.DATE_HUGE):
            return "EEEE, LLLL d, yyyy";
        case $5d7aec639bcea2c4$var$stringify($9BxO1.TIME_SIMPLE):
            return "h:mm a";
        case $5d7aec639bcea2c4$var$stringify($9BxO1.TIME_WITH_SECONDS):
            return "h:mm:ss a";
        case $5d7aec639bcea2c4$var$stringify($9BxO1.TIME_WITH_SHORT_OFFSET):
            return "h:mm a";
        case $5d7aec639bcea2c4$var$stringify($9BxO1.TIME_WITH_LONG_OFFSET):
            return "h:mm a";
        case $5d7aec639bcea2c4$var$stringify($9BxO1.TIME_24_SIMPLE):
            return "HH:mm";
        case $5d7aec639bcea2c4$var$stringify($9BxO1.TIME_24_WITH_SECONDS):
            return "HH:mm:ss";
        case $5d7aec639bcea2c4$var$stringify($9BxO1.TIME_24_WITH_SHORT_OFFSET):
            return "HH:mm";
        case $5d7aec639bcea2c4$var$stringify($9BxO1.TIME_24_WITH_LONG_OFFSET):
            return "HH:mm";
        case $5d7aec639bcea2c4$var$stringify($9BxO1.DATETIME_SHORT):
            return "M/d/yyyy, h:mm a";
        case $5d7aec639bcea2c4$var$stringify($9BxO1.DATETIME_MED):
            return "LLL d, yyyy, h:mm a";
        case $5d7aec639bcea2c4$var$stringify($9BxO1.DATETIME_FULL):
            return "LLLL d, yyyy, h:mm a";
        case $5d7aec639bcea2c4$var$stringify($9BxO1.DATETIME_HUGE):
            return dateTimeHuge;
        case $5d7aec639bcea2c4$var$stringify($9BxO1.DATETIME_SHORT_WITH_SECONDS):
            return "M/d/yyyy, h:mm:ss a";
        case $5d7aec639bcea2c4$var$stringify($9BxO1.DATETIME_MED_WITH_SECONDS):
            return "LLL d, yyyy, h:mm:ss a";
        case $5d7aec639bcea2c4$var$stringify($9BxO1.DATETIME_MED_WITH_WEEKDAY):
            return "EEE, d LLL yyyy, h:mm a";
        case $5d7aec639bcea2c4$var$stringify($9BxO1.DATETIME_FULL_WITH_SECONDS):
            return "LLLL d, yyyy, h:mm:ss a";
        case $5d7aec639bcea2c4$var$stringify($9BxO1.DATETIME_HUGE_WITH_SECONDS):
            return "EEEE, LLLL d, yyyy, h:mm:ss a";
        default:
            return dateTimeHuge;
    }
}

});
parcelRegister("9BxO1", function(module, exports) {

$parcel$export(module.exports, "DATE_SHORT", () => $6fe1cae7d94d272a$export$19db5ed0dfbf6b4);
$parcel$export(module.exports, "DATE_MED", () => $6fe1cae7d94d272a$export$7f19f128b5a661d5);
$parcel$export(module.exports, "DATE_MED_WITH_WEEKDAY", () => $6fe1cae7d94d272a$export$7afd5e65ff14ad5f);
$parcel$export(module.exports, "DATE_FULL", () => $6fe1cae7d94d272a$export$e8af1c0b0290dbe2);
$parcel$export(module.exports, "DATE_HUGE", () => $6fe1cae7d94d272a$export$ab5c0d098dcfe775);
$parcel$export(module.exports, "TIME_SIMPLE", () => $6fe1cae7d94d272a$export$b4941e7fc62df1ff);
$parcel$export(module.exports, "TIME_WITH_SECONDS", () => $6fe1cae7d94d272a$export$61c7c50acaa56067);
$parcel$export(module.exports, "TIME_WITH_SHORT_OFFSET", () => $6fe1cae7d94d272a$export$417ed025e483567);
$parcel$export(module.exports, "TIME_WITH_LONG_OFFSET", () => $6fe1cae7d94d272a$export$e0d12640fceb849c);
$parcel$export(module.exports, "TIME_24_SIMPLE", () => $6fe1cae7d94d272a$export$7333d0894ea2a492);
$parcel$export(module.exports, "TIME_24_WITH_SECONDS", () => $6fe1cae7d94d272a$export$2664018dfbf7eca);
$parcel$export(module.exports, "TIME_24_WITH_SHORT_OFFSET", () => $6fe1cae7d94d272a$export$3f5c467c8b3c85f6);
$parcel$export(module.exports, "TIME_24_WITH_LONG_OFFSET", () => $6fe1cae7d94d272a$export$edc722d6385d5cfa);
$parcel$export(module.exports, "DATETIME_SHORT", () => $6fe1cae7d94d272a$export$434cdda648f6d8ed);
$parcel$export(module.exports, "DATETIME_SHORT_WITH_SECONDS", () => $6fe1cae7d94d272a$export$115df8ec21cc4422);
$parcel$export(module.exports, "DATETIME_MED", () => $6fe1cae7d94d272a$export$2a10deefdeef9026);
$parcel$export(module.exports, "DATETIME_MED_WITH_SECONDS", () => $6fe1cae7d94d272a$export$652ead5a5aee93d0);
$parcel$export(module.exports, "DATETIME_MED_WITH_WEEKDAY", () => $6fe1cae7d94d272a$export$97006f3c2fab9954);
$parcel$export(module.exports, "DATETIME_FULL", () => $6fe1cae7d94d272a$export$6fbcfb06dd40694b);
$parcel$export(module.exports, "DATETIME_FULL_WITH_SECONDS", () => $6fe1cae7d94d272a$export$9ae9ad238dcfe6df);
$parcel$export(module.exports, "DATETIME_HUGE", () => $6fe1cae7d94d272a$export$c01f9be9042ca6d2);
$parcel$export(module.exports, "DATETIME_HUGE_WITH_SECONDS", () => $6fe1cae7d94d272a$export$c3b12c6a0fb1f516);
/**
 * @private
 */ const $6fe1cae7d94d272a$var$n = "numeric", $6fe1cae7d94d272a$var$s = "short", $6fe1cae7d94d272a$var$l = "long";
const $6fe1cae7d94d272a$export$19db5ed0dfbf6b4 = {
    year: $6fe1cae7d94d272a$var$n,
    month: $6fe1cae7d94d272a$var$n,
    day: $6fe1cae7d94d272a$var$n
};
const $6fe1cae7d94d272a$export$7f19f128b5a661d5 = {
    year: $6fe1cae7d94d272a$var$n,
    month: $6fe1cae7d94d272a$var$s,
    day: $6fe1cae7d94d272a$var$n
};
const $6fe1cae7d94d272a$export$7afd5e65ff14ad5f = {
    year: $6fe1cae7d94d272a$var$n,
    month: $6fe1cae7d94d272a$var$s,
    day: $6fe1cae7d94d272a$var$n,
    weekday: $6fe1cae7d94d272a$var$s
};
const $6fe1cae7d94d272a$export$e8af1c0b0290dbe2 = {
    year: $6fe1cae7d94d272a$var$n,
    month: $6fe1cae7d94d272a$var$l,
    day: $6fe1cae7d94d272a$var$n
};
const $6fe1cae7d94d272a$export$ab5c0d098dcfe775 = {
    year: $6fe1cae7d94d272a$var$n,
    month: $6fe1cae7d94d272a$var$l,
    day: $6fe1cae7d94d272a$var$n,
    weekday: $6fe1cae7d94d272a$var$l
};
const $6fe1cae7d94d272a$export$b4941e7fc62df1ff = {
    hour: $6fe1cae7d94d272a$var$n,
    minute: $6fe1cae7d94d272a$var$n
};
const $6fe1cae7d94d272a$export$61c7c50acaa56067 = {
    hour: $6fe1cae7d94d272a$var$n,
    minute: $6fe1cae7d94d272a$var$n,
    second: $6fe1cae7d94d272a$var$n
};
const $6fe1cae7d94d272a$export$417ed025e483567 = {
    hour: $6fe1cae7d94d272a$var$n,
    minute: $6fe1cae7d94d272a$var$n,
    second: $6fe1cae7d94d272a$var$n,
    timeZoneName: $6fe1cae7d94d272a$var$s
};
const $6fe1cae7d94d272a$export$e0d12640fceb849c = {
    hour: $6fe1cae7d94d272a$var$n,
    minute: $6fe1cae7d94d272a$var$n,
    second: $6fe1cae7d94d272a$var$n,
    timeZoneName: $6fe1cae7d94d272a$var$l
};
const $6fe1cae7d94d272a$export$7333d0894ea2a492 = {
    hour: $6fe1cae7d94d272a$var$n,
    minute: $6fe1cae7d94d272a$var$n,
    hourCycle: "h23"
};
const $6fe1cae7d94d272a$export$2664018dfbf7eca = {
    hour: $6fe1cae7d94d272a$var$n,
    minute: $6fe1cae7d94d272a$var$n,
    second: $6fe1cae7d94d272a$var$n,
    hourCycle: "h23"
};
const $6fe1cae7d94d272a$export$3f5c467c8b3c85f6 = {
    hour: $6fe1cae7d94d272a$var$n,
    minute: $6fe1cae7d94d272a$var$n,
    second: $6fe1cae7d94d272a$var$n,
    hourCycle: "h23",
    timeZoneName: $6fe1cae7d94d272a$var$s
};
const $6fe1cae7d94d272a$export$edc722d6385d5cfa = {
    hour: $6fe1cae7d94d272a$var$n,
    minute: $6fe1cae7d94d272a$var$n,
    second: $6fe1cae7d94d272a$var$n,
    hourCycle: "h23",
    timeZoneName: $6fe1cae7d94d272a$var$l
};
const $6fe1cae7d94d272a$export$434cdda648f6d8ed = {
    year: $6fe1cae7d94d272a$var$n,
    month: $6fe1cae7d94d272a$var$n,
    day: $6fe1cae7d94d272a$var$n,
    hour: $6fe1cae7d94d272a$var$n,
    minute: $6fe1cae7d94d272a$var$n
};
const $6fe1cae7d94d272a$export$115df8ec21cc4422 = {
    year: $6fe1cae7d94d272a$var$n,
    month: $6fe1cae7d94d272a$var$n,
    day: $6fe1cae7d94d272a$var$n,
    hour: $6fe1cae7d94d272a$var$n,
    minute: $6fe1cae7d94d272a$var$n,
    second: $6fe1cae7d94d272a$var$n
};
const $6fe1cae7d94d272a$export$2a10deefdeef9026 = {
    year: $6fe1cae7d94d272a$var$n,
    month: $6fe1cae7d94d272a$var$s,
    day: $6fe1cae7d94d272a$var$n,
    hour: $6fe1cae7d94d272a$var$n,
    minute: $6fe1cae7d94d272a$var$n
};
const $6fe1cae7d94d272a$export$652ead5a5aee93d0 = {
    year: $6fe1cae7d94d272a$var$n,
    month: $6fe1cae7d94d272a$var$s,
    day: $6fe1cae7d94d272a$var$n,
    hour: $6fe1cae7d94d272a$var$n,
    minute: $6fe1cae7d94d272a$var$n,
    second: $6fe1cae7d94d272a$var$n
};
const $6fe1cae7d94d272a$export$97006f3c2fab9954 = {
    year: $6fe1cae7d94d272a$var$n,
    month: $6fe1cae7d94d272a$var$s,
    day: $6fe1cae7d94d272a$var$n,
    weekday: $6fe1cae7d94d272a$var$s,
    hour: $6fe1cae7d94d272a$var$n,
    minute: $6fe1cae7d94d272a$var$n
};
const $6fe1cae7d94d272a$export$6fbcfb06dd40694b = {
    year: $6fe1cae7d94d272a$var$n,
    month: $6fe1cae7d94d272a$var$l,
    day: $6fe1cae7d94d272a$var$n,
    hour: $6fe1cae7d94d272a$var$n,
    minute: $6fe1cae7d94d272a$var$n,
    timeZoneName: $6fe1cae7d94d272a$var$s
};
const $6fe1cae7d94d272a$export$9ae9ad238dcfe6df = {
    year: $6fe1cae7d94d272a$var$n,
    month: $6fe1cae7d94d272a$var$l,
    day: $6fe1cae7d94d272a$var$n,
    hour: $6fe1cae7d94d272a$var$n,
    minute: $6fe1cae7d94d272a$var$n,
    second: $6fe1cae7d94d272a$var$n,
    timeZoneName: $6fe1cae7d94d272a$var$s
};
const $6fe1cae7d94d272a$export$c01f9be9042ca6d2 = {
    year: $6fe1cae7d94d272a$var$n,
    month: $6fe1cae7d94d272a$var$l,
    day: $6fe1cae7d94d272a$var$n,
    weekday: $6fe1cae7d94d272a$var$l,
    hour: $6fe1cae7d94d272a$var$n,
    minute: $6fe1cae7d94d272a$var$n,
    timeZoneName: $6fe1cae7d94d272a$var$l
};
const $6fe1cae7d94d272a$export$c3b12c6a0fb1f516 = {
    year: $6fe1cae7d94d272a$var$n,
    month: $6fe1cae7d94d272a$var$l,
    day: $6fe1cae7d94d272a$var$n,
    weekday: $6fe1cae7d94d272a$var$l,
    hour: $6fe1cae7d94d272a$var$n,
    minute: $6fe1cae7d94d272a$var$n,
    second: $6fe1cae7d94d272a$var$n,
    timeZoneName: $6fe1cae7d94d272a$var$l
};

});

parcelRegister("8XfCP", function(module, exports) {

$parcel$export(module.exports, "isUndefined", () => $684ff445874f3639$export$fce6876652108ab);
$parcel$export(module.exports, "isNumber", () => $684ff445874f3639$export$7e4aa119212bc614);
$parcel$export(module.exports, "isInteger", () => $684ff445874f3639$export$a287f47fed4544b8);
$parcel$export(module.exports, "isString", () => $684ff445874f3639$export$844ec244b1367d54);
$parcel$export(module.exports, "isDate", () => $684ff445874f3639$export$871608497c498473);
$parcel$export(module.exports, "hasRelative", () => $684ff445874f3639$export$36c4ef3ee752f47f);
$parcel$export(module.exports, "hasLocaleWeekInfo", () => $684ff445874f3639$export$deee12cd7a09c6e1);
$parcel$export(module.exports, "maybeArray", () => $684ff445874f3639$export$334480083959f08a);
$parcel$export(module.exports, "bestBy", () => $684ff445874f3639$export$d322b949ce403225);
$parcel$export(module.exports, "pick", () => $684ff445874f3639$export$357523c63a2253b9);
$parcel$export(module.exports, "hasOwnProperty", () => $684ff445874f3639$export$5a15a386532a5ea4);
$parcel$export(module.exports, "validateWeekSettings", () => $684ff445874f3639$export$68b4772f5ae7dec6);
$parcel$export(module.exports, "integerBetween", () => $684ff445874f3639$export$9fe178c7471c91db);
$parcel$export(module.exports, "padStart", () => $684ff445874f3639$export$36cf564d487b5178);
$parcel$export(module.exports, "parseInteger", () => $684ff445874f3639$export$7181a16950b3209d);
$parcel$export(module.exports, "parseFloating", () => $684ff445874f3639$export$ccc9a81fca9859cb);
$parcel$export(module.exports, "parseMillis", () => $684ff445874f3639$export$3989d60cf160c565);
$parcel$export(module.exports, "roundTo", () => $684ff445874f3639$export$7978a6ddf29f4374);
$parcel$export(module.exports, "isLeapYear", () => $684ff445874f3639$export$553d7fa8e3805fc0);
$parcel$export(module.exports, "daysInYear", () => $684ff445874f3639$export$3913210603d8e9ae);
$parcel$export(module.exports, "daysInMonth", () => $684ff445874f3639$export$4169ecd548fbc13a);
$parcel$export(module.exports, "objToLocalTS", () => $684ff445874f3639$export$c7c54c08b29e0736);
$parcel$export(module.exports, "weeksInWeekYear", () => $684ff445874f3639$export$fcb8e8d76a6f2959);
$parcel$export(module.exports, "untruncateYear", () => $684ff445874f3639$export$b7a39e2df70cc6be);
$parcel$export(module.exports, "parseZoneInfo", () => $684ff445874f3639$export$897bcc5343b25acd);
$parcel$export(module.exports, "signedOffset", () => $684ff445874f3639$export$f60aa7c70b05722d);
$parcel$export(module.exports, "asNumber", () => $684ff445874f3639$export$37576b9ba69b50db);
$parcel$export(module.exports, "normalizeObject", () => $684ff445874f3639$export$ba17feb4405f3f38);
$parcel$export(module.exports, "formatOffset", () => $684ff445874f3639$export$a52dc21079c7600);
$parcel$export(module.exports, "timeObject", () => $684ff445874f3639$export$4401ec2a884d3d6f);
/*
  This is just a junk drawer, containing anything used across multiple classes.
  Because Luxon is small(ish), this should stay small and we won't worry about splitting
  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
*/ 
var $4vuXU = parcelRequire("4vuXU");

var $h0abM = parcelRequire("h0abM");

var $70NWa = parcelRequire("70NWa");
function $684ff445874f3639$export$fce6876652108ab(o) {
    return typeof o === "undefined";
}
function $684ff445874f3639$export$7e4aa119212bc614(o) {
    return typeof o === "number";
}
function $684ff445874f3639$export$a287f47fed4544b8(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $684ff445874f3639$export$844ec244b1367d54(o) {
    return typeof o === "string";
}
function $684ff445874f3639$export$871608497c498473(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
function $684ff445874f3639$export$36c4ef3ee752f47f() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
function $684ff445874f3639$export$deee12cd7a09c6e1() {
    try {
        return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
    } catch (e) {
        return false;
    }
}
function $684ff445874f3639$export$334480083959f08a(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $684ff445874f3639$export$d322b949ce403225(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce((best, next)=>{
        const pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $684ff445874f3639$export$357523c63a2253b9(obj, keys) {
    return keys.reduce((a, k)=>{
        a[k] = obj[k];
        return a;
    }, {});
}
function $684ff445874f3639$export$5a15a386532a5ea4(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $684ff445874f3639$export$68b4772f5ae7dec6(settings) {
    if (settings == null) return null;
    else if (typeof settings !== "object") throw new (0, $4vuXU.InvalidArgumentError)("Week settings must be an object");
    else {
        if (!$684ff445874f3639$export$9fe178c7471c91db(settings.firstDay, 1, 7) || !$684ff445874f3639$export$9fe178c7471c91db(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some((v)=>!$684ff445874f3639$export$9fe178c7471c91db(v, 1, 7))) throw new (0, $4vuXU.InvalidArgumentError)("Invalid week settings");
        return {
            firstDay: settings.firstDay,
            minimalDays: settings.minimalDays,
            weekend: Array.from(settings.weekend)
        };
    }
}
function $684ff445874f3639$export$9fe178c7471c91db(thing, bottom, top) {
    return $684ff445874f3639$export$a287f47fed4544b8(thing) && thing >= bottom && thing <= top;
}
function $684ff445874f3639$export$3b34b3b59ac8ca7e(x, n) {
    return x - n * Math.floor(x / n);
}
function $684ff445874f3639$export$36cf564d487b5178(input, n = 2) {
    const isNeg = input < 0;
    let padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $684ff445874f3639$export$7181a16950b3209d(string) {
    if ($684ff445874f3639$export$fce6876652108ab(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $684ff445874f3639$export$ccc9a81fca9859cb(string) {
    if ($684ff445874f3639$export$fce6876652108ab(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $684ff445874f3639$export$3989d60cf160c565(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($684ff445874f3639$export$fce6876652108ab(fraction) || fraction === null || fraction === "") return undefined;
    else {
        const f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $684ff445874f3639$export$7978a6ddf29f4374(number, digits, towardZero = false) {
    const factor = 10 ** digits, rounder = towardZero ? Math.trunc : Math.round;
    return rounder(number * factor) / factor;
}
function $684ff445874f3639$export$553d7fa8e3805fc0(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $684ff445874f3639$export$3913210603d8e9ae(year) {
    return $684ff445874f3639$export$553d7fa8e3805fc0(year) ? 366 : 365;
}
function $684ff445874f3639$export$4169ecd548fbc13a(year, month) {
    const modMonth = $684ff445874f3639$export$3b34b3b59ac8ca7e(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $684ff445874f3639$export$553d7fa8e3805fc0(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
function $684ff445874f3639$export$c7c54c08b29e0736(obj) {
    let d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function $684ff445874f3639$var$firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
    const fwdlw = (0, $70NWa.isoWeekdayToLocal)((0, $70NWa.dayOfWeek)(year, 1, minDaysInFirstWeek), startOfWeek);
    return -fwdlw + minDaysInFirstWeek - 1;
}
function $684ff445874f3639$export$fcb8e8d76a6f2959(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
    const weekOffset = $684ff445874f3639$var$firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
    const weekOffsetNext = $684ff445874f3639$var$firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
    return ($684ff445874f3639$export$3913210603d8e9ae(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function $684ff445874f3639$export$b7a39e2df70cc6be(year) {
    if (year > 99) return year;
    else return year > (0, $h0abM.default).twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
function $684ff445874f3639$export$897bcc5343b25acd(ts, offsetFormat, locale, timeZone = null) {
    const date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    const modified = {
        timeZoneName: offsetFormat,
        ...intlOpts
    };
    const parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find((m)=>m.type.toLowerCase() === "timezonename");
    return parsed ? parsed.value : null;
}
function $684ff445874f3639$export$f60aa7c70b05722d(offHourStr, offMinuteStr) {
    let offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    const offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
function $684ff445874f3639$export$37576b9ba69b50db(value) {
    const numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new (0, $4vuXU.InvalidArgumentError)(`Invalid unit value ${value}`);
    return numericValue;
}
function $684ff445874f3639$export$ba17feb4405f3f38(obj, normalizer) {
    const normalized = {};
    for(const u in obj)if ($684ff445874f3639$export$5a15a386532a5ea4(obj, u)) {
        const v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $684ff445874f3639$export$37576b9ba69b50db(v);
    }
    return normalized;
}
function $684ff445874f3639$export$a52dc21079c7600(offset, format) {
    const hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return `${sign}${$684ff445874f3639$export$36cf564d487b5178(hours, 2)}:${$684ff445874f3639$export$36cf564d487b5178(minutes, 2)}`;
        case "narrow":
            return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
        case "techie":
            return `${sign}${$684ff445874f3639$export$36cf564d487b5178(hours, 2)}${$684ff445874f3639$export$36cf564d487b5178(minutes, 2)}`;
        default:
            throw new RangeError(`Value format ${format} is out of range for property format`);
    }
}
function $684ff445874f3639$export$4401ec2a884d3d6f(obj) {
    return $684ff445874f3639$export$357523c63a2253b9(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}

});
parcelRegister("h0abM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c60a570f8c0c0fa9$export$2e2bcd8739ae039);

var $aJb6U = parcelRequire("aJb6U");

var $lzaec = parcelRequire("lzaec");

var $hi2rW = parcelRequire("hi2rW");

var $bxn76 = parcelRequire("bxn76");

var $fcA62 = parcelRequire("fcA62");

var $8XfCP = parcelRequire("8XfCP");

var $8I8CV = parcelRequire("8I8CV");
let $c60a570f8c0c0fa9$var$now = ()=>Date.now(), $c60a570f8c0c0fa9$var$defaultZone = "system", $c60a570f8c0c0fa9$var$defaultLocale = null, $c60a570f8c0c0fa9$var$defaultNumberingSystem = null, $c60a570f8c0c0fa9$var$defaultOutputCalendar = null, $c60a570f8c0c0fa9$var$twoDigitCutoffYear = 60, $c60a570f8c0c0fa9$var$throwOnInvalid, $c60a570f8c0c0fa9$var$defaultWeekSettings = null;
class $c60a570f8c0c0fa9$export$2e2bcd8739ae039 {
    /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */ static get now() {
        return $c60a570f8c0c0fa9$var$now;
    }
    /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */ static set now(n) {
        $c60a570f8c0c0fa9$var$now = n;
    }
    /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */ static set defaultZone(zone) {
        $c60a570f8c0c0fa9$var$defaultZone = zone;
    }
    /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */ static get defaultZone() {
        return (0, $fcA62.normalizeZone)($c60a570f8c0c0fa9$var$defaultZone, (0, $aJb6U.default).instance);
    }
    /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static get defaultLocale() {
        return $c60a570f8c0c0fa9$var$defaultLocale;
    }
    /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static set defaultLocale(locale) {
        $c60a570f8c0c0fa9$var$defaultLocale = locale;
    }
    /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static get defaultNumberingSystem() {
        return $c60a570f8c0c0fa9$var$defaultNumberingSystem;
    }
    /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static set defaultNumberingSystem(numberingSystem) {
        $c60a570f8c0c0fa9$var$defaultNumberingSystem = numberingSystem;
    }
    /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static get defaultOutputCalendar() {
        return $c60a570f8c0c0fa9$var$defaultOutputCalendar;
    }
    /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static set defaultOutputCalendar(outputCalendar) {
        $c60a570f8c0c0fa9$var$defaultOutputCalendar = outputCalendar;
    }
    /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */ /**
   * @return {WeekSettings|null}
   */ static get defaultWeekSettings() {
        return $c60a570f8c0c0fa9$var$defaultWeekSettings;
    }
    /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */ static set defaultWeekSettings(weekSettings) {
        $c60a570f8c0c0fa9$var$defaultWeekSettings = (0, $8XfCP.validateWeekSettings)(weekSettings);
    }
    /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */ static get twoDigitCutoffYear() {
        return $c60a570f8c0c0fa9$var$twoDigitCutoffYear;
    }
    /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */ static set twoDigitCutoffYear(cutoffYear) {
        $c60a570f8c0c0fa9$var$twoDigitCutoffYear = cutoffYear % 100;
    }
    /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */ static get throwOnInvalid() {
        return $c60a570f8c0c0fa9$var$throwOnInvalid;
    }
    /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */ static set throwOnInvalid(t) {
        $c60a570f8c0c0fa9$var$throwOnInvalid = t;
    }
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ static resetCaches() {
        (0, $hi2rW.default).resetCache();
        (0, $lzaec.default).resetCache();
        (0, $bxn76.default).resetCache();
        (0, $8I8CV.resetDigitRegexCache)();
    }
}

});
parcelRegister("aJb6U", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cf6b9aa774cac41$export$2e2bcd8739ae039);

var $8XfCP = parcelRequire("8XfCP");

var $5uPms = parcelRequire("5uPms");
let $7cf6b9aa774cac41$var$singleton = null;
class $7cf6b9aa774cac41$export$2e2bcd8739ae039 extends (0, $5uPms.default) {
    /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */ static get instance() {
        if ($7cf6b9aa774cac41$var$singleton === null) $7cf6b9aa774cac41$var$singleton = new $7cf6b9aa774cac41$export$2e2bcd8739ae039();
        return $7cf6b9aa774cac41$var$singleton;
    }
    /** @override **/ get type() {
        return "system";
    }
    /** @override **/ get name() {
        return new Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    /** @override **/ get isUniversal() {
        return false;
    }
    /** @override **/ offsetName(ts, { format: format, locale: locale }) {
        return (0, $8XfCP.parseZoneInfo)(ts, format, locale);
    }
    /** @override **/ formatOffset(ts, format) {
        return (0, $8XfCP.formatOffset)(this.offset(ts), format);
    }
    /** @override **/ offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    }
    /** @override **/ equals(otherZone) {
        return otherZone.type === "system";
    }
    /** @override **/ get isValid() {
        return true;
    }
}

});
parcelRegister("5uPms", function(module, exports) {

$parcel$export(module.exports, "default", () => $400798580cebf122$export$2e2bcd8739ae039);

var $4vuXU = parcelRequire("4vuXU");
class $400798580cebf122$export$2e2bcd8739ae039 {
    /**
   * The type of zone
   * @abstract
   * @type {string}
   */ get type() {
        throw new (0, $4vuXU.ZoneIsAbstractError)();
    }
    /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */ get name() {
        throw new (0, $4vuXU.ZoneIsAbstractError)();
    }
    /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */ get ianaName() {
        return this.name;
    }
    /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */ get isUniversal() {
        throw new (0, $4vuXU.ZoneIsAbstractError)();
    }
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ offsetName(ts, opts) {
        throw new (0, $4vuXU.ZoneIsAbstractError)();
    }
    /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ formatOffset(ts, format) {
        throw new (0, $4vuXU.ZoneIsAbstractError)();
    }
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ offset(ts) {
        throw new (0, $4vuXU.ZoneIsAbstractError)();
    }
    /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ equals(otherZone) {
        throw new (0, $4vuXU.ZoneIsAbstractError)();
    }
    /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */ get isValid() {
        throw new (0, $4vuXU.ZoneIsAbstractError)();
    }
}

});


parcelRegister("lzaec", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb34ccf22ee3bedf$export$2e2bcd8739ae039);

var $8XfCP = parcelRequire("8XfCP");

var $5uPms = parcelRequire("5uPms");
let $fb34ccf22ee3bedf$var$dtfCache = {};
function $fb34ccf22ee3bedf$var$makeDTF(zone) {
    if (!$fb34ccf22ee3bedf$var$dtfCache[zone]) $fb34ccf22ee3bedf$var$dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
        hour12: false,
        timeZone: zone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        era: "short"
    });
    return $fb34ccf22ee3bedf$var$dtfCache[zone];
}
const $fb34ccf22ee3bedf$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function $fb34ccf22ee3bedf$var$hackyOffset(dtf, date) {
    const formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function $fb34ccf22ee3bedf$var$partsOffset(dtf, date) {
    const formatted = dtf.formatToParts(date);
    const filled = [];
    for(let i = 0; i < formatted.length; i++){
        const { type: type, value: value } = formatted[i];
        const pos = $fb34ccf22ee3bedf$var$typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!(0, $8XfCP.isUndefined)(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
let $fb34ccf22ee3bedf$var$ianaZoneCache = {};
class $fb34ccf22ee3bedf$export$2e2bcd8739ae039 extends (0, $5uPms.default) {
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ static create(name) {
        if (!$fb34ccf22ee3bedf$var$ianaZoneCache[name]) $fb34ccf22ee3bedf$var$ianaZoneCache[name] = new $fb34ccf22ee3bedf$export$2e2bcd8739ae039(name);
        return $fb34ccf22ee3bedf$var$ianaZoneCache[name];
    }
    /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ static resetCache() {
        $fb34ccf22ee3bedf$var$ianaZoneCache = {};
        $fb34ccf22ee3bedf$var$dtfCache = {};
    }
    /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */ static isValidSpecifier(s) {
        return this.isValidZone(s);
    }
    /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */ static isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    }
    constructor(name){
        super();
        /** @private **/ this.zoneName = name;
        /** @private **/ this.valid = $fb34ccf22ee3bedf$export$2e2bcd8739ae039.isValidZone(name);
    }
    /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */ get type() {
        return "iana";
    }
    /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */ get name() {
        return this.zoneName;
    }
    /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */ get isUniversal() {
        return false;
    }
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ offsetName(ts, { format: format, locale: locale }) {
        return (0, $8XfCP.parseZoneInfo)(ts, format, locale, this.name);
    }
    /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ formatOffset(ts, format) {
        return (0, $8XfCP.formatOffset)(this.offset(ts), format);
    }
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ offset(ts) {
        const date = new Date(ts);
        if (isNaN(date)) return NaN;
        const dtf = $fb34ccf22ee3bedf$var$makeDTF(this.name);
        let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts ? $fb34ccf22ee3bedf$var$partsOffset(dtf, date) : $fb34ccf22ee3bedf$var$hackyOffset(dtf, date);
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        const adjustedHour = hour === 24 ? 0 : hour;
        const asUTC = (0, $8XfCP.objToLocalTS)({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        let asTS = +date;
        const over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    }
    /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    }
    /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */ get isValid() {
        return this.valid;
    }
}

});

parcelRegister("hi2rW", function(module, exports) {

$parcel$export(module.exports, "default", () => $c966048cba8727c2$export$2e2bcd8739ae039);

var $8XfCP = parcelRequire("8XfCP");

var $81AKw = parcelRequire("81AKw");

var $h0abM = parcelRequire("h0abM");

var $bxn76 = parcelRequire("bxn76");

var $lzaec = parcelRequire("lzaec");
// todo - remap caching
let $c966048cba8727c2$var$intlLFCache = {};
function $c966048cba8727c2$var$getCachedLF(locString, opts = {}) {
    const key = JSON.stringify([
        locString,
        opts
    ]);
    let dtf = $c966048cba8727c2$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $c966048cba8727c2$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
let $c966048cba8727c2$var$intlDTCache = {};
function $c966048cba8727c2$var$getCachedDTF(locString, opts = {}) {
    const key = JSON.stringify([
        locString,
        opts
    ]);
    let dtf = $c966048cba8727c2$var$intlDTCache[key];
    if (!dtf) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $c966048cba8727c2$var$intlDTCache[key] = dtf;
    }
    return dtf;
}
let $c966048cba8727c2$var$intlNumCache = {};
function $c966048cba8727c2$var$getCachedINF(locString, opts = {}) {
    const key = JSON.stringify([
        locString,
        opts
    ]);
    let inf = $c966048cba8727c2$var$intlNumCache[key];
    if (!inf) {
        inf = new Intl.NumberFormat(locString, opts);
        $c966048cba8727c2$var$intlNumCache[key] = inf;
    }
    return inf;
}
let $c966048cba8727c2$var$intlRelCache = {};
function $c966048cba8727c2$var$getCachedRTF(locString, opts = {}) {
    const { base: base, ...cacheKeyOpts } = opts; // exclude `base` from the options
    const key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    let inf = $c966048cba8727c2$var$intlRelCache[key];
    if (!inf) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $c966048cba8727c2$var$intlRelCache[key] = inf;
    }
    return inf;
}
let $c966048cba8727c2$var$sysLocaleCache = null;
function $c966048cba8727c2$var$systemLocale() {
    if ($c966048cba8727c2$var$sysLocaleCache) return $c966048cba8727c2$var$sysLocaleCache;
    else {
        $c966048cba8727c2$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $c966048cba8727c2$var$sysLocaleCache;
    }
}
let $c966048cba8727c2$var$weekInfoCache = {};
function $c966048cba8727c2$var$getCachedWeekInfo(locString) {
    let data = $c966048cba8727c2$var$weekInfoCache[locString];
    if (!data) {
        const locale = new Intl.Locale(locString);
        // browsers currently implement this as a property, but spec says it should be a getter function
        data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
        $c966048cba8727c2$var$weekInfoCache[locString] = data;
    }
    return data;
}
function $c966048cba8727c2$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    const xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    const uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        let options;
        let selectedStr;
        try {
            options = $c966048cba8727c2$var$getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            const smaller = localeStr.substring(0, uIndex);
            options = $c966048cba8727c2$var$getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        const { numberingSystem: numberingSystem, calendar: calendar } = options;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function $c966048cba8727c2$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += `-ca-${outputCalendar}`;
        if (numberingSystem) localeStr += `-nu-${numberingSystem}`;
        return localeStr;
    } else return localeStr;
}
function $c966048cba8727c2$var$mapMonths(f) {
    const ms = [];
    for(let i = 1; i <= 12; i++){
        const dt = (0, $bxn76.default).utc(2009, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $c966048cba8727c2$var$mapWeekdays(f) {
    const ms = [];
    for(let i = 1; i <= 7; i++){
        const dt = (0, $bxn76.default).utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $c966048cba8727c2$var$listStuff(loc, length, englishFn, intlFn) {
    const mode = loc.listingMode();
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $c966048cba8727c2$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
}
/**
 * @private
 */ class $c966048cba8727c2$var$PolyNumberFormatter {
    constructor(intl, forceSimple, opts){
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        const { padTo: padTo, floor: floor, ...otherOpts } = opts;
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            const intlOpts = {
                useGrouping: false,
                ...opts
            };
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $c966048cba8727c2$var$getCachedINF(intl, intlOpts);
        }
    }
    format(i) {
        if (this.inf) {
            const fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            const fixed = this.floor ? Math.floor(i) : (0, $8XfCP.roundTo)(i, 3);
            return (0, $8XfCP.padStart)(fixed, this.padTo);
        }
    }
}
/**
 * @private
 */ class $c966048cba8727c2$var$PolyDateFormatter {
    constructor(dt, intl, opts){
        this.opts = opts;
        this.originalZone = undefined;
        let z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            const gmtOffset = -1 * (dt.offset / 60);
            const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
            if (dt.offset !== 0 && (0, $lzaec.default).create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        const intlOpts = {
            ...this.opts
        };
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = $c966048cba8727c2$var$getCachedDTF(intl, intlOpts);
    }
    format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(({ value: value })=>value).join("");
        return this.dtf.format(this.dt.toJSDate());
    }
    formatToParts() {
        const parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map((part)=>{
            if (part.type === "timeZoneName") {
                const offsetName = this.originalZone.offsetName(this.dt.ts, {
                    locale: this.dt.locale,
                    format: this.opts.timeZoneName
                });
                return {
                    ...part,
                    value: offsetName
                };
            } else return part;
        });
        return parts;
    }
    resolvedOptions() {
        return this.dtf.resolvedOptions();
    }
}
/**
 * @private
 */ class $c966048cba8727c2$var$PolyRelFormatter {
    constructor(intl, isEnglish, opts){
        this.opts = {
            style: "long",
            ...opts
        };
        if (!isEnglish && (0, $8XfCP.hasRelative)()) this.rtf = $c966048cba8727c2$var$getCachedRTF(intl, opts);
    }
    format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $81AKw.formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
    formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    }
}
const $c966048cba8727c2$var$fallbackWeekSettings = {
    firstDay: 1,
    minimalDays: 4,
    weekend: [
        6,
        7
    ]
};
class $c966048cba8727c2$export$2e2bcd8739ae039 {
    static fromOpts(opts) {
        return $c966048cba8727c2$export$2e2bcd8739ae039.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
    }
    static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
        const specifiedLocale = locale || (0, $h0abM.default).defaultLocale;
        // the system locale is useful for human-readable strings but annoying for parsing/formatting known formats
        const localeR = specifiedLocale || (defaultToEN ? "en-US" : $c966048cba8727c2$var$systemLocale());
        const numberingSystemR = numberingSystem || (0, $h0abM.default).defaultNumberingSystem;
        const outputCalendarR = outputCalendar || (0, $h0abM.default).defaultOutputCalendar;
        const weekSettingsR = (0, $8XfCP.validateWeekSettings)(weekSettings) || (0, $h0abM.default).defaultWeekSettings;
        return new $c966048cba8727c2$export$2e2bcd8739ae039(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
    }
    static resetCache() {
        $c966048cba8727c2$var$sysLocaleCache = null;
        $c966048cba8727c2$var$intlDTCache = {};
        $c966048cba8727c2$var$intlNumCache = {};
        $c966048cba8727c2$var$intlRelCache = {};
    }
    static fromObject({ locale: locale, numberingSystem: numberingSystem, outputCalendar: outputCalendar, weekSettings: weekSettings } = {}) {
        return $c966048cba8727c2$export$2e2bcd8739ae039.create(locale, numberingSystem, outputCalendar, weekSettings);
    }
    constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale){
        const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = $c966048cba8727c2$var$parseLocaleString(locale);
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.weekSettings = weekSettings;
        this.intl = $c966048cba8727c2$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    get fastNumbers() {
        if (this.fastNumbersCached == null) this.fastNumbersCached = $c966048cba8727c2$var$supportsFastNumbers(this);
        return this.fastNumbersCached;
    }
    listingMode() {
        const isActuallyEn = this.isEnglish();
        const hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    }
    clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return $c966048cba8727c2$export$2e2bcd8739ae039.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, (0, $8XfCP.validateWeekSettings)(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    }
    redefaultToEN(alts = {}) {
        return this.clone({
            ...alts,
            defaultToEN: true
        });
    }
    redefaultToSystem(alts = {}) {
        return this.clone({
            ...alts,
            defaultToEN: false
        });
    }
    months(length, format = false) {
        return $c966048cba8727c2$var$listStuff(this, length, $81AKw.months, ()=>{
            const intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!this.monthsCache[formatStr][length]) this.monthsCache[formatStr][length] = $c966048cba8727c2$var$mapMonths((dt)=>this.extract(dt, intl, "month"));
            return this.monthsCache[formatStr][length];
        });
    }
    weekdays(length, format = false) {
        return $c966048cba8727c2$var$listStuff(this, length, $81AKw.weekdays, ()=>{
            const intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!this.weekdaysCache[formatStr][length]) this.weekdaysCache[formatStr][length] = $c966048cba8727c2$var$mapWeekdays((dt)=>this.extract(dt, intl, "weekday"));
            return this.weekdaysCache[formatStr][length];
        });
    }
    meridiems() {
        return $c966048cba8727c2$var$listStuff(this, undefined, ()=>$81AKw.meridiems, ()=>{
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!this.meridiemCache) {
                const intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                this.meridiemCache = [
                    (0, $bxn76.default).utc(2016, 11, 13, 9),
                    (0, $bxn76.default).utc(2016, 11, 13, 19)
                ].map((dt)=>this.extract(dt, intl, "dayperiod"));
            }
            return this.meridiemCache;
        });
    }
    eras(length) {
        return $c966048cba8727c2$var$listStuff(this, length, $81AKw.eras, ()=>{
            const intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!this.eraCache[length]) this.eraCache[length] = [
                (0, $bxn76.default).utc(-40, 1, 1),
                (0, $bxn76.default).utc(2017, 1, 1)
            ].map((dt)=>this.extract(dt, intl, "era"));
            return this.eraCache[length];
        });
    }
    extract(dt, intlOpts, field) {
        const df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find((m)=>m.type.toLowerCase() === field);
        return matching ? matching.value : null;
    }
    numberFormatter(opts = {}) {
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $c966048cba8727c2$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    }
    dtFormatter(dt, intlOpts = {}) {
        return new $c966048cba8727c2$var$PolyDateFormatter(dt, this.intl, intlOpts);
    }
    relFormatter(opts = {}) {
        return new $c966048cba8727c2$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    }
    listFormatter(opts = {}) {
        return $c966048cba8727c2$var$getCachedLF(this.intl, opts);
    }
    isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
    }
    getWeekSettings() {
        if (this.weekSettings) return this.weekSettings;
        else if (!(0, $8XfCP.hasLocaleWeekInfo)()) return $c966048cba8727c2$var$fallbackWeekSettings;
        else return $c966048cba8727c2$var$getCachedWeekInfo(this.locale);
    }
    getStartOfWeek() {
        return this.getWeekSettings().firstDay;
    }
    getMinDaysInFirstWeek() {
        return this.getWeekSettings().minimalDays;
    }
    getWeekendDays() {
        return this.getWeekSettings().weekend;
    }
    equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    }
    toString() {
        return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
    }
}

});

parcelRegister("fcA62", function(module, exports) {

$parcel$export(module.exports, "normalizeZone", () => $b113fa004f3324a6$export$4527f24d1e617e9);
/**
 * @private
 */ 
var $5uPms = parcelRequire("5uPms");

var $lzaec = parcelRequire("lzaec");

var $2S7RT = parcelRequire("2S7RT");

var $4JNEw = parcelRequire("4JNEw");

var $8XfCP = parcelRequire("8XfCP");

var $aJb6U = parcelRequire("aJb6U");
function $b113fa004f3324a6$export$4527f24d1e617e9(input, defaultZone) {
    let offset;
    if ((0, $8XfCP.isUndefined)(input) || input === null) return defaultZone;
    else if (input instanceof (0, $5uPms.default)) return input;
    else if ((0, $8XfCP.isString)(input)) {
        const lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return (0, $aJb6U.default).instance;
        else if (lowered === "utc" || lowered === "gmt") return (0, $2S7RT.default).utcInstance;
        else return (0, $2S7RT.default).parseSpecifier(lowered) || (0, $lzaec.default).create(input);
    } else if ((0, $8XfCP.isNumber)(input)) return (0, $2S7RT.default).instance(input);
    else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new (0, $4JNEw.default)(input);
}

});
parcelRegister("2S7RT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2176ba65e0762c93$export$2e2bcd8739ae039);

var $8XfCP = parcelRequire("8XfCP");

var $5uPms = parcelRequire("5uPms");
let $2176ba65e0762c93$var$singleton = null;
class $2176ba65e0762c93$export$2e2bcd8739ae039 extends (0, $5uPms.default) {
    /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */ static get utcInstance() {
        if ($2176ba65e0762c93$var$singleton === null) $2176ba65e0762c93$var$singleton = new $2176ba65e0762c93$export$2e2bcd8739ae039(0);
        return $2176ba65e0762c93$var$singleton;
    }
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ static instance(offset) {
        return offset === 0 ? $2176ba65e0762c93$export$2e2bcd8739ae039.utcInstance : new $2176ba65e0762c93$export$2e2bcd8739ae039(offset);
    }
    /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */ static parseSpecifier(s) {
        if (s) {
            const r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new $2176ba65e0762c93$export$2e2bcd8739ae039((0, $8XfCP.signedOffset)(r[1], r[2]));
        }
        return null;
    }
    constructor(offset){
        super();
        /** @private **/ this.fixed = offset;
    }
    /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */ get type() {
        return "fixed";
    }
    /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */ get name() {
        return this.fixed === 0 ? "UTC" : `UTC${(0, $8XfCP.formatOffset)(this.fixed, "narrow")}`;
    }
    /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */ get ianaName() {
        if (this.fixed === 0) return "Etc/UTC";
        else return `Etc/GMT${(0, $8XfCP.formatOffset)(-this.fixed, "narrow")}`;
    }
    /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */ offsetName() {
        return this.name;
    }
    /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ formatOffset(ts, format) {
        return (0, $8XfCP.formatOffset)(this.fixed, format);
    }
    /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */ get isUniversal() {
        return true;
    }
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */ offset() {
        return this.fixed;
    }
    /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    }
    /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */ get isValid() {
        return true;
    }
}

});

parcelRegister("4JNEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3731e15c0140b4f1$export$2e2bcd8739ae039);

var $5uPms = parcelRequire("5uPms");
class $3731e15c0140b4f1$export$2e2bcd8739ae039 extends (0, $5uPms.default) {
    constructor(zoneName){
        super();
        /**  @private */ this.zoneName = zoneName;
    }
    /** @override **/ get type() {
        return "invalid";
    }
    /** @override **/ get name() {
        return this.zoneName;
    }
    /** @override **/ get isUniversal() {
        return false;
    }
    /** @override **/ offsetName() {
        return null;
    }
    /** @override **/ formatOffset() {
        return "";
    }
    /** @override **/ offset() {
        return NaN;
    }
    /** @override **/ equals() {
        return false;
    }
    /** @override **/ get isValid() {
        return false;
    }
}

});


parcelRegister("8I8CV", function(module, exports) {

$parcel$export(module.exports, "parseDigits", () => $01a2fc62a26f0cd7$export$b37c688a581b2f6b);
$parcel$export(module.exports, "resetDigitRegexCache", () => $01a2fc62a26f0cd7$export$3d8a1d77340d0f52);
$parcel$export(module.exports, "digitRegex", () => $01a2fc62a26f0cd7$export$79fd8462ddaefe42);
const $01a2fc62a26f0cd7$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
const $01a2fc62a26f0cd7$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
const $01a2fc62a26f0cd7$var$hanidecChars = $01a2fc62a26f0cd7$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $01a2fc62a26f0cd7$export$b37c688a581b2f6b(str) {
    let value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(let i = 0; i < str.length; i++){
            const code = str.charCodeAt(i);
            if (str[i].search($01a2fc62a26f0cd7$var$numberingSystems.hanidec) !== -1) value += $01a2fc62a26f0cd7$var$hanidecChars.indexOf(str[i]);
            else for(const key in $01a2fc62a26f0cd7$var$numberingSystemsUTF16){
                const [min, max] = $01a2fc62a26f0cd7$var$numberingSystemsUTF16[key];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
// cache of {numberingSystem: {append: regex}}
let $01a2fc62a26f0cd7$var$digitRegexCache = {};
function $01a2fc62a26f0cd7$export$3d8a1d77340d0f52() {
    $01a2fc62a26f0cd7$var$digitRegexCache = {};
}
function $01a2fc62a26f0cd7$export$79fd8462ddaefe42({ numberingSystem: numberingSystem }, append = "") {
    const ns = numberingSystem || "latn";
    if (!$01a2fc62a26f0cd7$var$digitRegexCache[ns]) $01a2fc62a26f0cd7$var$digitRegexCache[ns] = {};
    if (!$01a2fc62a26f0cd7$var$digitRegexCache[ns][append]) $01a2fc62a26f0cd7$var$digitRegexCache[ns][append] = new RegExp(`${$01a2fc62a26f0cd7$var$numberingSystems[ns]}${append}`);
    return $01a2fc62a26f0cd7$var$digitRegexCache[ns][append];
}

});


parcelRegister("70NWa", function(module, exports) {

$parcel$export(module.exports, "dayOfWeek", () => $51af44fc17bd0022$export$a24aefd2b69080a9);
$parcel$export(module.exports, "isoWeekdayToLocal", () => $51af44fc17bd0022$export$3f8e22cccbc0b2cb);
$parcel$export(module.exports, "gregorianToWeek", () => $51af44fc17bd0022$export$5f982b63a73e30d5);
$parcel$export(module.exports, "weekToGregorian", () => $51af44fc17bd0022$export$82dcd477cc9ab67d);
$parcel$export(module.exports, "gregorianToOrdinal", () => $51af44fc17bd0022$export$78dea2ea345b4d9b);
$parcel$export(module.exports, "ordinalToGregorian", () => $51af44fc17bd0022$export$4ad8037b9961f2a);
$parcel$export(module.exports, "usesLocalWeekValues", () => $51af44fc17bd0022$export$527e2948b97774c0);
$parcel$export(module.exports, "hasInvalidWeekData", () => $51af44fc17bd0022$export$48544eeabe120519);
$parcel$export(module.exports, "hasInvalidOrdinalData", () => $51af44fc17bd0022$export$32d428c9a6653964);
$parcel$export(module.exports, "hasInvalidGregorianData", () => $51af44fc17bd0022$export$b807d5063f9fabd1);
$parcel$export(module.exports, "hasInvalidTimeData", () => $51af44fc17bd0022$export$f087c0ea5c760b87);

var $8XfCP = parcelRequire("8XfCP");

var $f6Tt7 = parcelRequire("f6Tt7");

var $4vuXU = parcelRequire("4vuXU");
const $51af44fc17bd0022$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $51af44fc17bd0022$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $51af44fc17bd0022$var$unitOutOfRange(unit, value) {
    return new (0, $f6Tt7.default)("unit out of range", `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`);
}
function $51af44fc17bd0022$export$a24aefd2b69080a9(year, month, day) {
    const d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    const js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function $51af44fc17bd0022$var$computeOrdinal(year, month, day) {
    return day + ((0, $8XfCP.isLeapYear)(year) ? $51af44fc17bd0022$var$leapLadder : $51af44fc17bd0022$var$nonLeapLadder)[month - 1];
}
function $51af44fc17bd0022$var$uncomputeOrdinal(year, ordinal) {
    const table = (0, $8XfCP.isLeapYear)(year) ? $51af44fc17bd0022$var$leapLadder : $51af44fc17bd0022$var$nonLeapLadder, month0 = table.findIndex((i)=>i < ordinal), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
function $51af44fc17bd0022$export$3f8e22cccbc0b2cb(isoWeekday, startOfWeek) {
    return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
function $51af44fc17bd0022$export$5f982b63a73e30d5(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
    const { year: year, month: month, day: day } = gregObj, ordinal = $51af44fc17bd0022$var$computeOrdinal(year, month, day), weekday = $51af44fc17bd0022$export$3f8e22cccbc0b2cb($51af44fc17bd0022$export$a24aefd2b69080a9(year, month, day), startOfWeek);
    let weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = (0, $8XfCP.weeksInWeekYear)(weekYear, minDaysInFirstWeek, startOfWeek);
    } else if (weekNumber > (0, $8XfCP.weeksInWeekYear)(year, minDaysInFirstWeek, startOfWeek)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return {
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday,
        ...(0, $8XfCP.timeObject)(gregObj)
    };
}
function $51af44fc17bd0022$export$82dcd477cc9ab67d(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
    const { weekYear: weekYear, weekNumber: weekNumber, weekday: weekday } = weekData, weekdayOfJan4 = $51af44fc17bd0022$export$3f8e22cccbc0b2cb($51af44fc17bd0022$export$a24aefd2b69080a9(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = (0, $8XfCP.daysInYear)(weekYear);
    let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += (0, $8XfCP.daysInYear)(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= (0, $8XfCP.daysInYear)(weekYear);
    } else year = weekYear;
    const { month: month, day: day } = $51af44fc17bd0022$var$uncomputeOrdinal(year, ordinal);
    return {
        year: year,
        month: month,
        day: day,
        ...(0, $8XfCP.timeObject)(weekData)
    };
}
function $51af44fc17bd0022$export$78dea2ea345b4d9b(gregData) {
    const { year: year, month: month, day: day } = gregData;
    const ordinal = $51af44fc17bd0022$var$computeOrdinal(year, month, day);
    return {
        year: year,
        ordinal: ordinal,
        ...(0, $8XfCP.timeObject)(gregData)
    };
}
function $51af44fc17bd0022$export$4ad8037b9961f2a(ordinalData) {
    const { year: year, ordinal: ordinal } = ordinalData;
    const { month: month, day: day } = $51af44fc17bd0022$var$uncomputeOrdinal(year, ordinal);
    return {
        year: year,
        month: month,
        day: day,
        ...(0, $8XfCP.timeObject)(ordinalData)
    };
}
function $51af44fc17bd0022$export$527e2948b97774c0(obj, loc) {
    const hasLocaleWeekData = !(0, $8XfCP.isUndefined)(obj.localWeekday) || !(0, $8XfCP.isUndefined)(obj.localWeekNumber) || !(0, $8XfCP.isUndefined)(obj.localWeekYear);
    if (hasLocaleWeekData) {
        const hasIsoWeekData = !(0, $8XfCP.isUndefined)(obj.weekday) || !(0, $8XfCP.isUndefined)(obj.weekNumber) || !(0, $8XfCP.isUndefined)(obj.weekYear);
        if (hasIsoWeekData) throw new (0, $4vuXU.ConflictingSpecificationError)("Cannot mix locale-based week fields with ISO-based week fields");
        if (!(0, $8XfCP.isUndefined)(obj.localWeekday)) obj.weekday = obj.localWeekday;
        if (!(0, $8XfCP.isUndefined)(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
        if (!(0, $8XfCP.isUndefined)(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
        delete obj.localWeekday;
        delete obj.localWeekNumber;
        delete obj.localWeekYear;
        return {
            minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
            startOfWeek: loc.getStartOfWeek()
        };
    } else return {
        minDaysInFirstWeek: 4,
        startOfWeek: 1
    };
}
function $51af44fc17bd0022$export$48544eeabe120519(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
    const validYear = (0, $8XfCP.isInteger)(obj.weekYear), validWeek = (0, $8XfCP.integerBetween)(obj.weekNumber, 1, (0, $8XfCP.weeksInWeekYear)(obj.weekYear, minDaysInFirstWeek, startOfWeek)), validWeekday = (0, $8XfCP.integerBetween)(obj.weekday, 1, 7);
    if (!validYear) return $51af44fc17bd0022$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $51af44fc17bd0022$var$unitOutOfRange("week", obj.weekNumber);
    else if (!validWeekday) return $51af44fc17bd0022$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $51af44fc17bd0022$export$32d428c9a6653964(obj) {
    const validYear = (0, $8XfCP.isInteger)(obj.year), validOrdinal = (0, $8XfCP.integerBetween)(obj.ordinal, 1, (0, $8XfCP.daysInYear)(obj.year));
    if (!validYear) return $51af44fc17bd0022$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $51af44fc17bd0022$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $51af44fc17bd0022$export$b807d5063f9fabd1(obj) {
    const validYear = (0, $8XfCP.isInteger)(obj.year), validMonth = (0, $8XfCP.integerBetween)(obj.month, 1, 12), validDay = (0, $8XfCP.integerBetween)(obj.day, 1, (0, $8XfCP.daysInMonth)(obj.year, obj.month));
    if (!validYear) return $51af44fc17bd0022$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $51af44fc17bd0022$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $51af44fc17bd0022$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $51af44fc17bd0022$export$f087c0ea5c760b87(obj) {
    const { hour: hour, minute: minute, second: second, millisecond: millisecond } = obj;
    const validHour = (0, $8XfCP.integerBetween)(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = (0, $8XfCP.integerBetween)(minute, 0, 59), validSecond = (0, $8XfCP.integerBetween)(second, 0, 59), validMillisecond = (0, $8XfCP.integerBetween)(millisecond, 0, 999);
    if (!validHour) return $51af44fc17bd0022$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $51af44fc17bd0022$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $51af44fc17bd0022$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $51af44fc17bd0022$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}

});
parcelRegister("f6Tt7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b002717cd3eee6b2$export$2e2bcd8739ae039);
class $b002717cd3eee6b2$export$2e2bcd8739ae039 {
    constructor(reason, explanation){
        this.reason = reason;
        this.explanation = explanation;
    }
    toMessage() {
        if (this.explanation) return `${this.reason}: ${this.explanation}`;
        else return this.reason;
    }
}

});





parcelRegister("jJizu", function(module, exports) {

$parcel$export(module.exports, "parseISODate", () => $e5d0a02fc8bd7056$export$ee8e61141c87635a);
$parcel$export(module.exports, "parseRFC2822Date", () => $e5d0a02fc8bd7056$export$22671fa29093a82f);
$parcel$export(module.exports, "parseHTTPDate", () => $e5d0a02fc8bd7056$export$6eac75d7e2e61231);
$parcel$export(module.exports, "parseISODuration", () => $e5d0a02fc8bd7056$export$87483128cec2621c);
$parcel$export(module.exports, "parseISOTimeOnly", () => $e5d0a02fc8bd7056$export$a8603b5245545f3e);
$parcel$export(module.exports, "parseSQL", () => $e5d0a02fc8bd7056$export$425a58f41d7e6b1e);

var $8XfCP = parcelRequire("8XfCP");

var $81AKw = parcelRequire("81AKw");

var $2S7RT = parcelRequire("2S7RT");

var $lzaec = parcelRequire("lzaec");
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ const $e5d0a02fc8bd7056$var$ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function $e5d0a02fc8bd7056$var$combineRegexes(...regexes) {
    const full = regexes.reduce((f, r)=>f + r.source, "");
    return RegExp(`^${full}$`);
}
function $e5d0a02fc8bd7056$var$combineExtractors(...extractors) {
    return (m)=>extractors.reduce(([mergedVals, mergedZone, cursor], ex)=>{
            const [val, zone, next] = ex(m, cursor);
            return [
                {
                    ...mergedVals,
                    ...val
                },
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
}
function $e5d0a02fc8bd7056$var$parse(s, ...patterns) {
    if (s == null) return [
        null,
        null
    ];
    for (const [regex, extractor] of patterns){
        const m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $e5d0a02fc8bd7056$var$simpleParse(...keys) {
    return (match, cursor)=>{
        const ret = {};
        let i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = (0, $8XfCP.parseInteger)(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
const $e5d0a02fc8bd7056$var$offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
const $e5d0a02fc8bd7056$var$isoExtendedZone = `(?:${$e5d0a02fc8bd7056$var$offsetRegex.source}?(?:\\[(${$e5d0a02fc8bd7056$var$ianaRegex.source})\\])?)?`;
const $e5d0a02fc8bd7056$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
const $e5d0a02fc8bd7056$var$isoTimeRegex = RegExp(`${$e5d0a02fc8bd7056$var$isoTimeBaseRegex.source}${$e5d0a02fc8bd7056$var$isoExtendedZone}`);
const $e5d0a02fc8bd7056$var$isoTimeExtensionRegex = RegExp(`(?:T${$e5d0a02fc8bd7056$var$isoTimeRegex.source})?`);
const $e5d0a02fc8bd7056$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
const $e5d0a02fc8bd7056$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
const $e5d0a02fc8bd7056$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/;
const $e5d0a02fc8bd7056$var$extractISOWeekData = $e5d0a02fc8bd7056$var$simpleParse("weekYear", "weekNumber", "weekDay");
const $e5d0a02fc8bd7056$var$extractISOOrdinalData = $e5d0a02fc8bd7056$var$simpleParse("year", "ordinal");
const $e5d0a02fc8bd7056$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
const $e5d0a02fc8bd7056$var$sqlTimeRegex = RegExp(`${$e5d0a02fc8bd7056$var$isoTimeBaseRegex.source} ?(?:${$e5d0a02fc8bd7056$var$offsetRegex.source}|(${$e5d0a02fc8bd7056$var$ianaRegex.source}))?`);
const $e5d0a02fc8bd7056$var$sqlTimeExtensionRegex = RegExp(`(?: ${$e5d0a02fc8bd7056$var$sqlTimeRegex.source})?`);
function $e5d0a02fc8bd7056$var$int(match, pos, fallback) {
    const m = match[pos];
    return (0, $8XfCP.isUndefined)(m) ? fallback : (0, $8XfCP.parseInteger)(m);
}
function $e5d0a02fc8bd7056$var$extractISOYmd(match, cursor) {
    const item = {
        year: $e5d0a02fc8bd7056$var$int(match, cursor),
        month: $e5d0a02fc8bd7056$var$int(match, cursor + 1, 1),
        day: $e5d0a02fc8bd7056$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $e5d0a02fc8bd7056$var$extractISOTime(match, cursor) {
    const item = {
        hours: $e5d0a02fc8bd7056$var$int(match, cursor, 0),
        minutes: $e5d0a02fc8bd7056$var$int(match, cursor + 1, 0),
        seconds: $e5d0a02fc8bd7056$var$int(match, cursor + 2, 0),
        milliseconds: (0, $8XfCP.parseMillis)(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $e5d0a02fc8bd7056$var$extractISOOffset(match, cursor) {
    const local = !match[cursor] && !match[cursor + 1], fullOffset = (0, $8XfCP.signedOffset)(match[cursor + 1], match[cursor + 2]), zone = local ? null : (0, $2S7RT.default).instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $e5d0a02fc8bd7056$var$extractIANAZone(match, cursor) {
    const zone = match[cursor] ? (0, $lzaec.default).create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
const $e5d0a02fc8bd7056$var$isoTimeOnly = RegExp(`^T?${$e5d0a02fc8bd7056$var$isoTimeBaseRegex.source}$`);
// ISO duration parsing
const $e5d0a02fc8bd7056$var$isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function $e5d0a02fc8bd7056$var$extractISODuration(match) {
    const [s, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] = match;
    const hasNegativePrefix = s[0] === "-";
    const negativeSeconds = secondStr && secondStr[0] === "-";
    const maybeNegate = (num, force = false)=>num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    return [
        {
            years: maybeNegate((0, $8XfCP.parseFloating)(yearStr)),
            months: maybeNegate((0, $8XfCP.parseFloating)(monthStr)),
            weeks: maybeNegate((0, $8XfCP.parseFloating)(weekStr)),
            days: maybeNegate((0, $8XfCP.parseFloating)(dayStr)),
            hours: maybeNegate((0, $8XfCP.parseFloating)(hourStr)),
            minutes: maybeNegate((0, $8XfCP.parseFloating)(minuteStr)),
            seconds: maybeNegate((0, $8XfCP.parseFloating)(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate((0, $8XfCP.parseMillis)(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
const $e5d0a02fc8bd7056$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $e5d0a02fc8bd7056$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    const result = {
        year: yearStr.length === 2 ? (0, $8XfCP.untruncateYear)((0, $8XfCP.parseInteger)(yearStr)) : (0, $8XfCP.parseInteger)(yearStr),
        month: $81AKw.monthsShort.indexOf(monthStr) + 1,
        day: (0, $8XfCP.parseInteger)(dayStr),
        hour: (0, $8XfCP.parseInteger)(hourStr),
        minute: (0, $8XfCP.parseInteger)(minuteStr)
    };
    if (secondStr) result.second = (0, $8XfCP.parseInteger)(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $81AKw.weekdaysLong.indexOf(weekdayStr) + 1 : $81AKw.weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
const $e5d0a02fc8bd7056$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $e5d0a02fc8bd7056$var$extractRFC2822(match) {
    const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr, obsOffset, milOffset, offHourStr, offMinuteStr] = match, result = $e5d0a02fc8bd7056$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    let offset;
    if (obsOffset) offset = $e5d0a02fc8bd7056$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = (0, $8XfCP.signedOffset)(offHourStr, offMinuteStr);
    return [
        result,
        new (0, $2S7RT.default)(offset)
    ];
}
function $e5d0a02fc8bd7056$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
const $e5d0a02fc8bd7056$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $e5d0a02fc8bd7056$var$rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $e5d0a02fc8bd7056$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $e5d0a02fc8bd7056$var$extractRFC1123Or850(match) {
    const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match, result = $e5d0a02fc8bd7056$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        (0, $2S7RT.default).utcInstance
    ];
}
function $e5d0a02fc8bd7056$var$extractASCII(match) {
    const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match, result = $e5d0a02fc8bd7056$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        (0, $2S7RT.default).utcInstance
    ];
}
const $e5d0a02fc8bd7056$var$isoYmdWithTimeExtensionRegex = $e5d0a02fc8bd7056$var$combineRegexes($e5d0a02fc8bd7056$var$isoYmdRegex, $e5d0a02fc8bd7056$var$isoTimeExtensionRegex);
const $e5d0a02fc8bd7056$var$isoWeekWithTimeExtensionRegex = $e5d0a02fc8bd7056$var$combineRegexes($e5d0a02fc8bd7056$var$isoWeekRegex, $e5d0a02fc8bd7056$var$isoTimeExtensionRegex);
const $e5d0a02fc8bd7056$var$isoOrdinalWithTimeExtensionRegex = $e5d0a02fc8bd7056$var$combineRegexes($e5d0a02fc8bd7056$var$isoOrdinalRegex, $e5d0a02fc8bd7056$var$isoTimeExtensionRegex);
const $e5d0a02fc8bd7056$var$isoTimeCombinedRegex = $e5d0a02fc8bd7056$var$combineRegexes($e5d0a02fc8bd7056$var$isoTimeRegex);
const $e5d0a02fc8bd7056$var$extractISOYmdTimeAndOffset = $e5d0a02fc8bd7056$var$combineExtractors($e5d0a02fc8bd7056$var$extractISOYmd, $e5d0a02fc8bd7056$var$extractISOTime, $e5d0a02fc8bd7056$var$extractISOOffset, $e5d0a02fc8bd7056$var$extractIANAZone);
const $e5d0a02fc8bd7056$var$extractISOWeekTimeAndOffset = $e5d0a02fc8bd7056$var$combineExtractors($e5d0a02fc8bd7056$var$extractISOWeekData, $e5d0a02fc8bd7056$var$extractISOTime, $e5d0a02fc8bd7056$var$extractISOOffset, $e5d0a02fc8bd7056$var$extractIANAZone);
const $e5d0a02fc8bd7056$var$extractISOOrdinalDateAndTime = $e5d0a02fc8bd7056$var$combineExtractors($e5d0a02fc8bd7056$var$extractISOOrdinalData, $e5d0a02fc8bd7056$var$extractISOTime, $e5d0a02fc8bd7056$var$extractISOOffset, $e5d0a02fc8bd7056$var$extractIANAZone);
const $e5d0a02fc8bd7056$var$extractISOTimeAndOffset = $e5d0a02fc8bd7056$var$combineExtractors($e5d0a02fc8bd7056$var$extractISOTime, $e5d0a02fc8bd7056$var$extractISOOffset, $e5d0a02fc8bd7056$var$extractIANAZone);
function $e5d0a02fc8bd7056$export$ee8e61141c87635a(s) {
    return $e5d0a02fc8bd7056$var$parse(s, [
        $e5d0a02fc8bd7056$var$isoYmdWithTimeExtensionRegex,
        $e5d0a02fc8bd7056$var$extractISOYmdTimeAndOffset
    ], [
        $e5d0a02fc8bd7056$var$isoWeekWithTimeExtensionRegex,
        $e5d0a02fc8bd7056$var$extractISOWeekTimeAndOffset
    ], [
        $e5d0a02fc8bd7056$var$isoOrdinalWithTimeExtensionRegex,
        $e5d0a02fc8bd7056$var$extractISOOrdinalDateAndTime
    ], [
        $e5d0a02fc8bd7056$var$isoTimeCombinedRegex,
        $e5d0a02fc8bd7056$var$extractISOTimeAndOffset
    ]);
}
function $e5d0a02fc8bd7056$export$22671fa29093a82f(s) {
    return $e5d0a02fc8bd7056$var$parse($e5d0a02fc8bd7056$var$preprocessRFC2822(s), [
        $e5d0a02fc8bd7056$var$rfc2822,
        $e5d0a02fc8bd7056$var$extractRFC2822
    ]);
}
function $e5d0a02fc8bd7056$export$6eac75d7e2e61231(s) {
    return $e5d0a02fc8bd7056$var$parse(s, [
        $e5d0a02fc8bd7056$var$rfc1123,
        $e5d0a02fc8bd7056$var$extractRFC1123Or850
    ], [
        $e5d0a02fc8bd7056$var$rfc850,
        $e5d0a02fc8bd7056$var$extractRFC1123Or850
    ], [
        $e5d0a02fc8bd7056$var$ascii,
        $e5d0a02fc8bd7056$var$extractASCII
    ]);
}
function $e5d0a02fc8bd7056$export$87483128cec2621c(s) {
    return $e5d0a02fc8bd7056$var$parse(s, [
        $e5d0a02fc8bd7056$var$isoDuration,
        $e5d0a02fc8bd7056$var$extractISODuration
    ]);
}
const $e5d0a02fc8bd7056$var$extractISOTimeOnly = $e5d0a02fc8bd7056$var$combineExtractors($e5d0a02fc8bd7056$var$extractISOTime);
function $e5d0a02fc8bd7056$export$a8603b5245545f3e(s) {
    return $e5d0a02fc8bd7056$var$parse(s, [
        $e5d0a02fc8bd7056$var$isoTimeOnly,
        $e5d0a02fc8bd7056$var$extractISOTimeOnly
    ]);
}
const $e5d0a02fc8bd7056$var$sqlYmdWithTimeExtensionRegex = $e5d0a02fc8bd7056$var$combineRegexes($e5d0a02fc8bd7056$var$sqlYmdRegex, $e5d0a02fc8bd7056$var$sqlTimeExtensionRegex);
const $e5d0a02fc8bd7056$var$sqlTimeCombinedRegex = $e5d0a02fc8bd7056$var$combineRegexes($e5d0a02fc8bd7056$var$sqlTimeRegex);
const $e5d0a02fc8bd7056$var$extractISOTimeOffsetAndIANAZone = $e5d0a02fc8bd7056$var$combineExtractors($e5d0a02fc8bd7056$var$extractISOTime, $e5d0a02fc8bd7056$var$extractISOOffset, $e5d0a02fc8bd7056$var$extractIANAZone);
function $e5d0a02fc8bd7056$export$425a58f41d7e6b1e(s) {
    return $e5d0a02fc8bd7056$var$parse(s, [
        $e5d0a02fc8bd7056$var$sqlYmdWithTimeExtensionRegex,
        $e5d0a02fc8bd7056$var$extractISOYmdTimeAndOffset
    ], [
        $e5d0a02fc8bd7056$var$sqlTimeCombinedRegex,
        $e5d0a02fc8bd7056$var$extractISOTimeOffsetAndIANAZone
    ]);
}

});


parcelRegister("crAXh", function(module, exports) {

$parcel$export(module.exports, "default", () => $90f4ac2690656069$export$2e2bcd8739ae039);

var $bxn76 = parcelRequire("bxn76");

var $fptYk = parcelRequire("fptYk");

var $h0abM = parcelRequire("h0abM");

var $4vuXU = parcelRequire("4vuXU");

var $f6Tt7 = parcelRequire("f6Tt7");

var $2lprD = parcelRequire("2lprD");

var $9BxO1 = parcelRequire("9BxO1");
const $90f4ac2690656069$var$INVALID = "Invalid Interval";
// checks if the start is equal to or before the end
function $90f4ac2690656069$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $90f4ac2690656069$export$2e2bcd8739ae039.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $90f4ac2690656069$export$2e2bcd8739ae039.invalid("missing or invalid end");
    else if (end < start) return $90f4ac2690656069$export$2e2bcd8739ae039.invalid("end before start", `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`);
    else return null;
}
class $90f4ac2690656069$export$2e2bcd8739ae039 {
    /**
   * @private
   */ constructor(config){
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ static invalid(reason, explanation = null) {
        if (!reason) throw new (0, $4vuXU.InvalidArgumentError)("need to specify a reason the Interval is invalid");
        const invalid = reason instanceof (0, $f6Tt7.default) ? reason : new (0, $f6Tt7.default)(reason, explanation);
        if ((0, $h0abM.default).throwOnInvalid) throw new (0, $4vuXU.InvalidIntervalError)(invalid);
        else return new $90f4ac2690656069$export$2e2bcd8739ae039({
            invalid: invalid
        });
    }
    /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */ static fromDateTimes(start, end) {
        const builtStart = (0, $bxn76.friendlyDateTime)(start), builtEnd = (0, $bxn76.friendlyDateTime)(end);
        const validateError = $90f4ac2690656069$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new $90f4ac2690656069$export$2e2bcd8739ae039({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    }
    /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ static after(start, duration) {
        const dur = (0, $fptYk.default).fromDurationLike(duration), dt = (0, $bxn76.friendlyDateTime)(start);
        return $90f4ac2690656069$export$2e2bcd8739ae039.fromDateTimes(dt, dt.plus(dur));
    }
    /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ static before(end, duration) {
        const dur = (0, $fptYk.default).fromDurationLike(duration), dt = (0, $bxn76.friendlyDateTime)(end);
        return $90f4ac2690656069$export$2e2bcd8739ae039.fromDateTimes(dt.minus(dur), dt);
    }
    /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */ static fromISO(text, opts) {
        const [s, e] = (text || "").split("/", 2);
        if (s && e) {
            let start, startIsValid;
            try {
                start = (0, $bxn76.default).fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            let end, endIsValid;
            try {
                end = (0, $bxn76.default).fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return $90f4ac2690656069$export$2e2bcd8739ae039.fromDateTimes(start, end);
            if (startIsValid) {
                const dur = (0, $fptYk.default).fromISO(e, opts);
                if (dur.isValid) return $90f4ac2690656069$export$2e2bcd8739ae039.after(start, dur);
            } else if (endIsValid) {
                const dur = (0, $fptYk.default).fromISO(s, opts);
                if (dur.isValid) return $90f4ac2690656069$export$2e2bcd8739ae039.before(end, dur);
            }
        }
        return $90f4ac2690656069$export$2e2bcd8739ae039.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
    /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ static isInterval(o) {
        return o && o.isLuxonInterval || false;
    }
    /**
   * Returns the start of the Interval
   * @type {DateTime}
   */ get start() {
        return this.isValid ? this.s : null;
    }
    /**
   * Returns the end of the Interval
   * @type {DateTime}
   */ get end() {
        return this.isValid ? this.e : null;
    }
    /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */ get isValid() {
        return this.invalidReason === null;
    }
    /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */ get invalidReason() {
        return this.invalid ? this.invalid.reason : null;
    }
    /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */ get invalidExplanation() {
        return this.invalid ? this.invalid.explanation : null;
    }
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ length(unit = "milliseconds") {
        return this.isValid ? this.toDuration(...[
            unit
        ]).get(unit) : NaN;
    }
    /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */ count(unit = "milliseconds", opts) {
        if (!this.isValid) return NaN;
        const start = this.start.startOf(unit, opts);
        let end;
        if (opts?.useLocaleWeeks) end = this.end.reconfigure({
            locale: start.locale
        });
        else end = this.end;
        end = end.startOf(unit, opts);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    }
    /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */ hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    }
    /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */ isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    }
    /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    }
    /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    }
    /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    }
    /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */ set({ start: start, end: end } = {}) {
        if (!this.isValid) return this;
        return $90f4ac2690656069$export$2e2bcd8739ae039.fromDateTimes(start || this.s, end || this.e);
    }
    /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */ splitAt(...dateTimes) {
        if (!this.isValid) return [];
        const sorted = dateTimes.map((0, $bxn76.friendlyDateTime)).filter((d)=>this.contains(d)).sort((a, b)=>a.toMillis() - b.toMillis()), results = [];
        let { s: s } = this, i = 0;
        while(s < this.e){
            const added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push($90f4ac2690656069$export$2e2bcd8739ae039.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    }
    /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */ splitBy(duration) {
        const dur = (0, $fptYk.default).fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        let { s: s } = this, idx = 1, next;
        const results = [];
        while(s < this.e){
            const added = this.start.plus(dur.mapUnits((x)=>x * idx));
            next = +added > +this.e ? this.e : added;
            results.push($90f4ac2690656069$export$2e2bcd8739ae039.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    }
    /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */ divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    }
    /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */ overlaps(other) {
        return this.e > other.s && this.s < other.e;
    }
    /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */ abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    }
    /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */ abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    }
    /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */ engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    }
    /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    }
    /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */ intersection(other) {
        if (!this.isValid) return this;
        const s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return $90f4ac2690656069$export$2e2bcd8739ae039.fromDateTimes(s, e);
    }
    /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */ union(other) {
        if (!this.isValid) return this;
        const s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return $90f4ac2690656069$export$2e2bcd8739ae039.fromDateTimes(s, e);
    }
    /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ static merge(intervals) {
        const [found, final] = intervals.sort((a, b)=>a.s - b.s).reduce(([sofar, current], item)=>{
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]);
        if (final) found.push(final);
        return found;
    }
    /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ static xor(intervals) {
        let start = null, currentCount = 0;
        const results = [], ends = intervals.map((i)=>[
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ]), flattened = Array.prototype.concat(...ends), arr = flattened.sort((a, b)=>a.time - b.time);
        for (const i of arr){
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push($90f4ac2690656069$export$2e2bcd8739ae039.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return $90f4ac2690656069$export$2e2bcd8739ae039.merge(results);
    }
    /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */ difference(...intervals) {
        return $90f4ac2690656069$export$2e2bcd8739ae039.xor([
            this
        ].concat(intervals)).map((i)=>this.intersection(i)).filter((i)=>i && !i.isEmpty());
    }
    /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */ toString() {
        if (!this.isValid) return $90f4ac2690656069$var$INVALID;
        return `[${this.s.toISO()} \u{2013} ${this.e.toISO()})`;
    }
    /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */ [Symbol.for("nodejs.util.inspect.custom")]() {
        if (this.isValid) return `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }`;
        else return `Interval { Invalid, reason: ${this.invalidReason} }`;
    }
    /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */ toLocaleString(formatOpts = $9BxO1.DATE_SHORT, opts = {}) {
        return this.isValid ? (0, $2lprD.default).create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : $90f4ac2690656069$var$INVALID;
    }
    /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ toISO(opts) {
        if (!this.isValid) return $90f4ac2690656069$var$INVALID;
        return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
    }
    /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */ toISODate() {
        if (!this.isValid) return $90f4ac2690656069$var$INVALID;
        return `${this.s.toISODate()}/${this.e.toISODate()}`;
    }
    /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ toISOTime(opts) {
        if (!this.isValid) return $90f4ac2690656069$var$INVALID;
        return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
    }
    /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */ toFormat(dateFormat, { separator: separator = " \u2013 " } = {}) {
        if (!this.isValid) return $90f4ac2690656069$var$INVALID;
        return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
    }
    /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */ toDuration(unit, opts) {
        if (!this.isValid) return (0, $fptYk.default).invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    }
    /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */ mapEndpoints(mapFn) {
        return $90f4ac2690656069$export$2e2bcd8739ae039.fromDateTimes(mapFn(this.s), mapFn(this.e));
    }
}

});

parcelRegister("s4LIV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0546509c899410b0$export$2e2bcd8739ae039);

var $bxn76 = parcelRequire("bxn76");

var $h0abM = parcelRequire("h0abM");

var $hi2rW = parcelRequire("hi2rW");

var $lzaec = parcelRequire("lzaec");

var $fcA62 = parcelRequire("fcA62");

var $8XfCP = parcelRequire("8XfCP");
class $0546509c899410b0$export$2e2bcd8739ae039 {
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ static hasDST(zone = (0, $h0abM.default).defaultZone) {
        const proto = (0, $bxn76.default).now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    }
    /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */ static isValidIANAZone(zone) {
        return (0, $lzaec.default).isValidZone(zone);
    }
    /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */ static normalizeZone(input) {
        return (0, $fcA62.normalizeZone)(input, (0, $h0abM.default).defaultZone);
    }
    /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */ static getStartOfWeek({ locale: locale = null, locObj: locObj = null } = {}) {
        return (locObj || (0, $hi2rW.default).create(locale)).getStartOfWeek();
    }
    /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */ static getMinimumDaysInFirstWeek({ locale: locale = null, locObj: locObj = null } = {}) {
        return (locObj || (0, $hi2rW.default).create(locale)).getMinDaysInFirstWeek();
    }
    /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */ static getWeekendWeekdays({ locale: locale = null, locObj: locObj = null } = {}) {
        // copy the array, because we cache it internally
        return (locObj || (0, $hi2rW.default).create(locale)).getWeekendDays().slice();
    }
    /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */ static months(length = "long", { locale: locale = null, numberingSystem: numberingSystem = null, locObj: locObj = null, outputCalendar: outputCalendar = "gregory" } = {}) {
        return (locObj || (0, $hi2rW.default).create(locale, numberingSystem, outputCalendar)).months(length);
    }
    /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */ static monthsFormat(length = "long", { locale: locale = null, numberingSystem: numberingSystem = null, locObj: locObj = null, outputCalendar: outputCalendar = "gregory" } = {}) {
        return (locObj || (0, $hi2rW.default).create(locale, numberingSystem, outputCalendar)).months(length, true);
    }
    /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */ static weekdays(length = "long", { locale: locale = null, numberingSystem: numberingSystem = null, locObj: locObj = null } = {}) {
        return (locObj || (0, $hi2rW.default).create(locale, numberingSystem, null)).weekdays(length);
    }
    /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */ static weekdaysFormat(length = "long", { locale: locale = null, numberingSystem: numberingSystem = null, locObj: locObj = null } = {}) {
        return (locObj || (0, $hi2rW.default).create(locale, numberingSystem, null)).weekdays(length, true);
    }
    /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */ static meridiems({ locale: locale = null } = {}) {
        return (0, $hi2rW.default).create(locale).meridiems();
    }
    /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */ static eras(length = "short", { locale: locale = null } = {}) {
        return (0, $hi2rW.default).create(locale, null, "gregory").eras(length);
    }
    /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */ static features() {
        return {
            relative: (0, $8XfCP.hasRelative)(),
            localeWeek: (0, $8XfCP.hasLocaleWeekInfo)()
        };
    }
}

});

parcelRegister("4Plx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $383ca0ab4c42750e$export$2e2bcd8739ae039);

var $fptYk = parcelRequire("fptYk");
function $383ca0ab4c42750e$var$dayDiff(earlier, later) {
    const utcDayStart = (dt)=>dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf(), ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor((0, $fptYk.default).fromMillis(ms).as("days"));
}
function $383ca0ab4c42750e$var$highOrderDiffs(cursor, later, units) {
    const differs = [
        [
            "years",
            (a, b)=>b.year - a.year
        ],
        [
            "quarters",
            (a, b)=>b.quarter - a.quarter + (b.year - a.year) * 4
        ],
        [
            "months",
            (a, b)=>b.month - a.month + (b.year - a.year) * 12
        ],
        [
            "weeks",
            (a, b)=>{
                const days = $383ca0ab4c42750e$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $383ca0ab4c42750e$var$dayDiff
        ]
    ];
    const results = {};
    const earlier = cursor;
    let lowestOrder, highWater;
    /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */ for (const [unit, differ] of differs)if (units.indexOf(unit) >= 0) {
        lowestOrder = unit;
        results[unit] = differ(cursor, later);
        highWater = earlier.plus(results);
        if (highWater > later) {
            // we overshot the end point, backtrack cursor by 1
            results[unit]--;
            cursor = earlier.plus(results);
            // if we are still overshooting now, we need to backtrack again
            // this happens in certain situations when diffing times in different zones,
            // because this calculation ignores time zones
            if (cursor > later) {
                // keep the "overshot by 1" around as highWater
                highWater = cursor;
                // backtrack cursor by 1
                results[unit]--;
                cursor = earlier.plus(results);
            }
        } else cursor = highWater;
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $383ca0ab4c42750e$export$2e2bcd8739ae039(earlier, later, units, opts) {
    let [cursor, results, highWater, lowestOrder] = $383ca0ab4c42750e$var$highOrderDiffs(earlier, later, units);
    const remainingMillis = later - cursor;
    const lowerOrderUnits = units.filter((u)=>[
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0);
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) highWater = cursor.plus({
            [lowestOrder]: 1
        });
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    const duration = (0, $fptYk.default).fromObject(results, opts);
    if (lowerOrderUnits.length > 0) return (0, $fptYk.default).fromMillis(remainingMillis, opts).shiftTo(...lowerOrderUnits).plus(duration);
    else return duration;
}

});

parcelRegister("kdX7T", function(module, exports) {

$parcel$export(module.exports, "formatOptsToTokens", () => $eb92e2c9b38813f9$export$fb8d7a00a19893f6);
$parcel$export(module.exports, "expandMacroTokens", () => $eb92e2c9b38813f9$export$518029bd3d2f8586);
$parcel$export(module.exports, "TokenParser", () => $eb92e2c9b38813f9$export$c758afbeb88a407b);
$parcel$export(module.exports, "explainFromTokens", () => $eb92e2c9b38813f9$export$8388bdfbc6b581fa);
$parcel$export(module.exports, "parseFromTokens", () => $eb92e2c9b38813f9$export$d3d42e05768c662d);

var $8XfCP = parcelRequire("8XfCP");

var $2lprD = parcelRequire("2lprD");

var $2S7RT = parcelRequire("2S7RT");

var $lzaec = parcelRequire("lzaec");

var $bxn76 = parcelRequire("bxn76");

var $8I8CV = parcelRequire("8I8CV");

var $4vuXU = parcelRequire("4vuXU");
const $eb92e2c9b38813f9$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $eb92e2c9b38813f9$var$intUnit(regex, post = (i)=>i) {
    return {
        regex: regex,
        deser: ([s])=>post((0, $8I8CV.parseDigits)(s))
    };
}
const $eb92e2c9b38813f9$var$NBSP = String.fromCharCode(160);
const $eb92e2c9b38813f9$var$spaceOrNBSP = `[ ${$eb92e2c9b38813f9$var$NBSP}]`;
const $eb92e2c9b38813f9$var$spaceOrNBSPRegExp = new RegExp($eb92e2c9b38813f9$var$spaceOrNBSP, "g");
function $eb92e2c9b38813f9$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($eb92e2c9b38813f9$var$spaceOrNBSPRegExp, $eb92e2c9b38813f9$var$spaceOrNBSP);
}
function $eb92e2c9b38813f9$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($eb92e2c9b38813f9$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $eb92e2c9b38813f9$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($eb92e2c9b38813f9$var$fixListRegex).join("|")),
        deser: ([s])=>strings.findIndex((i)=>$eb92e2c9b38813f9$var$stripInsensitivities(s) === $eb92e2c9b38813f9$var$stripInsensitivities(i)) + startIndex
    };
}
function $eb92e2c9b38813f9$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: ([, h, m])=>(0, $8XfCP.signedOffset)(h, m),
        groups: groups
    };
}
function $eb92e2c9b38813f9$var$simple(regex) {
    return {
        regex: regex,
        deser: ([s])=>s
    };
}
function $eb92e2c9b38813f9$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
/**
 * @param token
 * @param {Locale} loc
 */ function $eb92e2c9b38813f9$var$unitForToken(token, loc) {
    const one = (0, $8I8CV.digitRegex)(loc), two = (0, $8I8CV.digitRegex)(loc, "{2}"), three = (0, $8I8CV.digitRegex)(loc, "{3}"), four = (0, $8I8CV.digitRegex)(loc, "{4}"), six = (0, $8I8CV.digitRegex)(loc, "{6}"), oneOrTwo = (0, $8I8CV.digitRegex)(loc, "{1,2}"), oneToThree = (0, $8I8CV.digitRegex)(loc, "{1,3}"), oneToSix = (0, $8I8CV.digitRegex)(loc, "{1,6}"), oneToNine = (0, $8I8CV.digitRegex)(loc, "{1,9}"), twoToFour = (0, $8I8CV.digitRegex)(loc, "{2,4}"), fourToSix = (0, $8I8CV.digitRegex)(loc, "{4,6}"), literal = (t)=>({
            regex: RegExp($eb92e2c9b38813f9$var$escapeToken(t.val)),
            deser: ([s])=>s,
            literal: true
        }), unitate = (t)=>{
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $eb92e2c9b38813f9$var$oneOf(loc.eras("short"), 0);
            case "GG":
                return $eb92e2c9b38813f9$var$oneOf(loc.eras("long"), 0);
            // years
            case "y":
                return $eb92e2c9b38813f9$var$intUnit(oneToSix);
            case "yy":
                return $eb92e2c9b38813f9$var$intUnit(twoToFour, (0, $8XfCP.untruncateYear));
            case "yyyy":
                return $eb92e2c9b38813f9$var$intUnit(four);
            case "yyyyy":
                return $eb92e2c9b38813f9$var$intUnit(fourToSix);
            case "yyyyyy":
                return $eb92e2c9b38813f9$var$intUnit(six);
            // months
            case "M":
                return $eb92e2c9b38813f9$var$intUnit(oneOrTwo);
            case "MM":
                return $eb92e2c9b38813f9$var$intUnit(two);
            case "MMM":
                return $eb92e2c9b38813f9$var$oneOf(loc.months("short", true), 1);
            case "MMMM":
                return $eb92e2c9b38813f9$var$oneOf(loc.months("long", true), 1);
            case "L":
                return $eb92e2c9b38813f9$var$intUnit(oneOrTwo);
            case "LL":
                return $eb92e2c9b38813f9$var$intUnit(two);
            case "LLL":
                return $eb92e2c9b38813f9$var$oneOf(loc.months("short", false), 1);
            case "LLLL":
                return $eb92e2c9b38813f9$var$oneOf(loc.months("long", false), 1);
            // dates
            case "d":
                return $eb92e2c9b38813f9$var$intUnit(oneOrTwo);
            case "dd":
                return $eb92e2c9b38813f9$var$intUnit(two);
            // ordinals
            case "o":
                return $eb92e2c9b38813f9$var$intUnit(oneToThree);
            case "ooo":
                return $eb92e2c9b38813f9$var$intUnit(three);
            // time
            case "HH":
                return $eb92e2c9b38813f9$var$intUnit(two);
            case "H":
                return $eb92e2c9b38813f9$var$intUnit(oneOrTwo);
            case "hh":
                return $eb92e2c9b38813f9$var$intUnit(two);
            case "h":
                return $eb92e2c9b38813f9$var$intUnit(oneOrTwo);
            case "mm":
                return $eb92e2c9b38813f9$var$intUnit(two);
            case "m":
                return $eb92e2c9b38813f9$var$intUnit(oneOrTwo);
            case "q":
                return $eb92e2c9b38813f9$var$intUnit(oneOrTwo);
            case "qq":
                return $eb92e2c9b38813f9$var$intUnit(two);
            case "s":
                return $eb92e2c9b38813f9$var$intUnit(oneOrTwo);
            case "ss":
                return $eb92e2c9b38813f9$var$intUnit(two);
            case "S":
                return $eb92e2c9b38813f9$var$intUnit(oneToThree);
            case "SSS":
                return $eb92e2c9b38813f9$var$intUnit(three);
            case "u":
                return $eb92e2c9b38813f9$var$simple(oneToNine);
            case "uu":
                return $eb92e2c9b38813f9$var$simple(oneOrTwo);
            case "uuu":
                return $eb92e2c9b38813f9$var$intUnit(one);
            // meridiem
            case "a":
                return $eb92e2c9b38813f9$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $eb92e2c9b38813f9$var$intUnit(four);
            case "kk":
                return $eb92e2c9b38813f9$var$intUnit(twoToFour, (0, $8XfCP.untruncateYear));
            // weekNumber (W)
            case "W":
                return $eb92e2c9b38813f9$var$intUnit(oneOrTwo);
            case "WW":
                return $eb92e2c9b38813f9$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $eb92e2c9b38813f9$var$intUnit(one);
            case "EEE":
                return $eb92e2c9b38813f9$var$oneOf(loc.weekdays("short", false), 1);
            case "EEEE":
                return $eb92e2c9b38813f9$var$oneOf(loc.weekdays("long", false), 1);
            case "ccc":
                return $eb92e2c9b38813f9$var$oneOf(loc.weekdays("short", true), 1);
            case "cccc":
                return $eb92e2c9b38813f9$var$oneOf(loc.weekdays("long", true), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $eb92e2c9b38813f9$var$offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
            case "ZZZ":
                return $eb92e2c9b38813f9$var$offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $eb92e2c9b38813f9$var$simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return $eb92e2c9b38813f9$var$simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    const unit = unitate(token) || {
        invalidReason: $eb92e2c9b38813f9$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
const $eb92e2c9b38813f9$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour12: {
        numeric: "h",
        "2-digit": "hh"
    },
    hour24: {
        numeric: "H",
        "2-digit": "HH"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function $eb92e2c9b38813f9$var$tokenForPart(part, formatOpts, resolvedOpts) {
    const { type: type, value: value } = part;
    if (type === "literal") {
        const isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    const style = formatOpts[type];
    // The user might have explicitly specified hour12 or hourCycle
    // if so, respect their decision
    // if not, refer back to the resolvedOpts, which are based on the locale
    let actualType = type;
    if (type === "hour") {
        if (formatOpts.hour12 != null) actualType = formatOpts.hour12 ? "hour12" : "hour24";
        else if (formatOpts.hourCycle != null) {
            if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") actualType = "hour12";
            else actualType = "hour24";
        } else // tokens only differentiate between 24 hours or not,
        // so we do not need to check hourCycle here, which is less supported anyways
        actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
    let val = $eb92e2c9b38813f9$var$partTypeStyleToTokenVal[actualType];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $eb92e2c9b38813f9$var$buildRegex(units) {
    const re = units.map((u)=>u.regex).reduce((f, r)=>`${f}(${r.source})`, "");
    return [
        `^${re}$`,
        units
    ];
}
function $eb92e2c9b38813f9$var$match(input, regex, handlers) {
    const matches = input.match(regex);
    if (matches) {
        const all = {};
        let matchIndex = 1;
        for(const i in handlers)if ((0, $8XfCP.hasOwnProperty)(handlers, i)) {
            const h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $eb92e2c9b38813f9$var$dateTimeFromMatches(matches) {
    const toField = (token)=>{
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    let zone = null;
    let specificOffset;
    if (!(0, $8XfCP.isUndefined)(matches.z)) zone = (0, $lzaec.default).create(matches.z);
    if (!(0, $8XfCP.isUndefined)(matches.Z)) {
        if (!zone) zone = new (0, $2S7RT.default)(matches.Z);
        specificOffset = matches.Z;
    }
    if (!(0, $8XfCP.isUndefined)(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!(0, $8XfCP.isUndefined)(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!(0, $8XfCP.isUndefined)(matches.u)) matches.S = (0, $8XfCP.parseMillis)(matches.u);
    const vals = Object.keys(matches).reduce((r, k)=>{
        const f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
let $eb92e2c9b38813f9$var$dummyDateTimeCache = null;
function $eb92e2c9b38813f9$var$getDummyDateTime() {
    if (!$eb92e2c9b38813f9$var$dummyDateTimeCache) $eb92e2c9b38813f9$var$dummyDateTimeCache = (0, $bxn76.default).fromMillis(1555555555555);
    return $eb92e2c9b38813f9$var$dummyDateTimeCache;
}
function $eb92e2c9b38813f9$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    const formatOpts = (0, $2lprD.default).macroTokenToFormatOpts(token.val);
    const tokens = $eb92e2c9b38813f9$export$fb8d7a00a19893f6(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function $eb92e2c9b38813f9$export$518029bd3d2f8586(tokens, locale) {
    return Array.prototype.concat(...tokens.map((t)=>$eb92e2c9b38813f9$var$maybeExpandMacroToken(t, locale)));
}
class $eb92e2c9b38813f9$export$c758afbeb88a407b {
    constructor(locale, format){
        this.locale = locale;
        this.format = format;
        this.tokens = $eb92e2c9b38813f9$export$518029bd3d2f8586((0, $2lprD.default).parseFormat(format), locale);
        this.units = this.tokens.map((t)=>$eb92e2c9b38813f9$var$unitForToken(t, locale));
        this.disqualifyingUnit = this.units.find((t)=>t.invalidReason);
        if (!this.disqualifyingUnit) {
            const [regexString, handlers] = $eb92e2c9b38813f9$var$buildRegex(this.units);
            this.regex = RegExp(regexString, "i");
            this.handlers = handlers;
        }
    }
    explainFromTokens(input) {
        if (!this.isValid) return {
            input: input,
            tokens: this.tokens,
            invalidReason: this.invalidReason
        };
        else {
            const [rawMatches, matches] = $eb92e2c9b38813f9$var$match(input, this.regex, this.handlers), [result, zone, specificOffset] = matches ? $eb92e2c9b38813f9$var$dateTimeFromMatches(matches) : [
                null,
                null,
                undefined
            ];
            if ((0, $8XfCP.hasOwnProperty)(matches, "a") && (0, $8XfCP.hasOwnProperty)(matches, "H")) throw new (0, $4vuXU.ConflictingSpecificationError)("Can't include meridiem when specifying 24-hour format");
            return {
                input: input,
                tokens: this.tokens,
                regex: this.regex,
                rawMatches: rawMatches,
                matches: matches,
                result: result,
                zone: zone,
                specificOffset: specificOffset
            };
        }
    }
    get isValid() {
        return !this.disqualifyingUnit;
    }
    get invalidReason() {
        return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
    }
}
function $eb92e2c9b38813f9$export$8388bdfbc6b581fa(locale, input, format) {
    const parser = new $eb92e2c9b38813f9$export$c758afbeb88a407b(locale, format);
    return parser.explainFromTokens(input);
}
function $eb92e2c9b38813f9$export$d3d42e05768c662d(locale, input, format) {
    const { result: result, zone: zone, specificOffset: specificOffset, invalidReason: invalidReason } = $eb92e2c9b38813f9$export$8388bdfbc6b581fa(locale, input, format);
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function $eb92e2c9b38813f9$export$fb8d7a00a19893f6(formatOpts, locale) {
    if (!formatOpts) return null;
    const formatter = (0, $2lprD.default).create(locale, formatOpts);
    const df = formatter.dtFormatter($eb92e2c9b38813f9$var$getDummyDateTime());
    const parts = df.formatToParts();
    const resolvedOpts = df.resolvedOptions();
    return parts.map((p)=>$eb92e2c9b38813f9$var$tokenForPart(p, formatOpts, resolvedOpts));
}

});




parcelRegister("1WwBr", function(module, exports) {

$parcel$export(module.exports, "selectMinMax", () => $16a47f75af03de52$export$bad37a894becb61f);
//
// these widgets hook to an existing select and predefined values to the search
// and do not render their select based on the available (facet) data.
// use an Algolia widget if the UX experience is for a dynamic facet.
//
//
// perform a filter that is within [num] inclusive
//    1. attribute >= num
//
// perform a filter that is within [min,max] inclusive
//    1. attribute >= min
//    2. attribute <= max
//
// perform a filter that is less than [,max] inclusive
//    1. attribute <= max
const $16a47f75af03de52$export$bad37a894becb61f = (renderOptions, isFirstRender)=>{
    const { widgetParams: widgetParams, refine: refine } = renderOptions;
    if (!isFirstRender) // no need to perform anything if not the first render as it is predefined select element
    return;
    // add an event listener to the select element to refine when changed.
    const el = document.querySelector(widgetParams.el);
    el.addEventListener("change", (event)=>{
        event.preventDefault();
        let value = event.target.value;
        // if the value is empty, then refine to the default value
        if (!value) {
            refine();
            return;
        }
        // strip the [ ] brackets, and split.
        value = value.replace(/[\[\]]/g, "");
        let range = value.split(",");
        //
        if (range.length < 1) refine();
        else if (range.length == 1) //
        refine([
            range[0] || undefined
        ]);
        else refine([
            range[0] || undefined,
            range[1] || undefined
        ]);
    });
};

});


//# sourceMappingURL=search-facets.2e82cefb.js.map
